(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return inputDate$1; }), Promise.resolve().then(function () { return customerRegisterForm$1; }), Promise.resolve().then(function () { return customerLoginForm$1; }), Promise.resolve().then(function () { return customerActivateForm$1; }), Promise.resolve().then(function () { return customerResetPassword$1; }), Promise.resolve().then(function () { return customerRecoverPassword$1; }), Promise.resolve().then(function () { return customerAddressForm$1; }), Promise.resolve().then(function () { return customerUpdateForm$1; }), Promise.resolve().then(function () { return customerChatButton$1; }), Promise.resolve().then(function () { return returnHistory$1; }), Promise.resolve().then(function () { return returnButton$1; }), Promise.resolve().then(function () { return orderDetails$1; }), Promise.resolve().then(function () { return customerDeletedAccount$1; }), Promise.resolve().then(function () { return customerOrderHistory$1; }), Promise.resolve().then(function () { return bisProductCard$1; }), Promise.resolve().then(function () { return bisGrid$1; }), Promise.resolve().then(function () { return fragmentAddressBlock$1; }), Promise.resolve().then(function () { return fragmentProfile$1; }), Promise.resolve().then(function () { return componentPasswordInput$1; }), Promise.resolve().then(function () { return componentCustomerNav$1; }), Promise.resolve().then(function () { return componentCustomerOrderDetails$1; }), Promise.resolve().then(function () { return componentInvoiceButton$1; })];
        const componentsObj = hydrateComponents(components);
        await componentsObj.hydrate?.();
      })();
    });

    const {
      dateRegex
    } = window.PoleneLibs.ConstantsDate;
    const DateFormat$2 = window.PoleneLibs.DateFormat;
    const {
      getElementsByRef: getElementsByRef$2
    } = window.PoleneLibs.Refs;
    var inputDate = () => {
      const {
        inputDate
      } = getElementsByRef$2('input-date');
      if (!inputDate) return;
      const dateFormat = new DateFormat$2();
      const inputs = Array.isArray(inputDate) ? [...inputDate] : [inputDate];
      const init = () => {
        setupPlaceholders();
        formatExistingValues();
        setEventListeners();
      };
      const setupPlaceholders = () => {
        inputs.forEach(input => {
          input.placeholder = document.documentElement.dir === 'rtl' ? `\u2066(${input.dataset.tOptional})  ${dateFormat.placeholder}\u2069` : `${dateFormat.placeholder}  (${input.dataset.tOptional})`;
        });
      };
      const formatExistingValues = () => {
        inputs.forEach(input => {
          if (input.value) {
            const timestamp = dateFormat.parse(input.value);
            if (timestamp) {
              input.value = dateFormat.format(timestamp, dateFormat.defaultFormat) ?? '';
            }
          }
        });
      };
      const setEventListeners = () => {
        inputs.forEach(input => {
          input.addEventListener('blur', handleDateInputBlur);
          input.addEventListener('input', handleInput);
        });
      };
      const removeEventListeners = () => {
        inputs.forEach(input => {
          input.removeEventListener('blur', handleDateInputBlur);
          input.removeEventListener('input', handleInput);
        });
      };
      const handleDateInputBlur = event => {
        if (!event.target) return;
        const input = event.target;
        if (input.value) {
          const timestamp = dateFormat.parse(input.value);
          if (timestamp) {
            input.value = dateFormat.format(timestamp, dateFormat.defaultFormat) ?? '';
          }
        }
      };
      function handleInput() {
        this.value = this.value.replace(dateRegex, '');
      }
      init();
      return () => {
        removeEventListeners();
      };
    };

    var inputDate$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: inputDate
    });

    const cleanPath = path => path.replace(/\/+/g, '/');
    const cleanPaths = paths => {
      return Object.fromEntries(Object.entries(paths).map(([key, path]) => [key, cleanPath(path)]));
    };
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const ROOT_PATH = window?.Shopify?.routes?.root || '/';
    const PROXY_BASE_PATH = cleanPath(`${ROOT_PATH}/apps/polene-theme-features`);
    const REDIRECT_URL = cleanPaths({
      WISHLIST: `${ROOT_PATH}/pages/wishlist`,
      ACCOUNT: `${ROOT_PATH}/account`,
      LOGIN: `${ROOT_PATH}/account/login`,
      LOGIN_MULTI_PASS: `${ROOT_PATH}/account/login/multipass`
    });
    const API_STOREFRONT = '/api/2025-01/graphql.json';
    const API_PROXY = {
      RETURNS: PROXY_BASE_PATH + '/order-returns',
      RETURN_BUTTON: PROXY_BASE_PATH + '/order-return-button',
      ORDER_HISTORY: PROXY_BASE_PATH + '/order-history',
      ORDER_INVOICE: PROXY_BASE_PATH + '/order-invoice',
      ORDER_CREDIT_NOTE: PROXY_BASE_PATH + '/order-credit-note',
      ORDER_DETAILS: PROXY_BASE_PATH + '/order-details',
      ORDER_DETAILS_SAP: PROXY_BASE_PATH + '/order-details-sap',
      DELETE_ACCOUNT: PROXY_BASE_PATH + '/delete-account',
      CREATE_CUSTOMER: PROXY_BASE_PATH + '/customer-create',
      UPDATE_CUSTOMER: PROXY_BASE_PATH + '/customer-update',
      CUSTOMER_SMS_CONSENT: PROXY_BASE_PATH + '/customer-sms-marketing',
      CUSTOMER_WISHLIST: PROXY_BASE_PATH + '/customer-wishlist',
      STOREFRONT: PROXY_BASE_PATH + '/storefront',
      MARKETING_SUBSCRIBE: PROXY_BASE_PATH + '/marketing-subscribe',
      BACK_IN_STOCK_SUBSCRIBE: PROXY_BASE_PATH + '/back-in-stock-subscribe',
      WISHLIST: PROXY_BASE_PATH + '/wishlist',
      ORDER_TRACKER: PROXY_BASE_PATH + '/order-tracker',
      BIS_SUBSCRIPTIONS: PROXY_BASE_PATH + '/back-in-stock-subscriptions',
      ALL_ARTICLES: PROXY_BASE_PATH + '/blog-articles',
      CART_IDENTITY: PROXY_BASE_PATH + '/cart-identity',
      CUSTOMER_IDENTITY: PROXY_BASE_PATH + '/customer-identity',
      KLAVIYO_RESOLVER: PROXY_BASE_PATH + '/klaviyo-resolver'
    };
    window.P1?.klaviyo?.public_key;
    window.P1?.klaviyo?.list_id;

    var ErrorTypes;
    (function (ErrorTypes) {
      ErrorTypes["invalidTitle"] = "invalid_title";
      ErrorTypes["invalidName"] = "invalid_name";
      ErrorTypes["invalidCivility"] = "invalid_civility";
      ErrorTypes["nonLatinCharacters"] = "contains_non_latin_characters";
      ErrorTypes["maxLengthExceeded"] = "max_length_exceeded";
      ErrorTypes["minLength"] = "min_length";
      ErrorTypes["containsNumbers"] = "contains_numbers";
      ErrorTypes["containsSpecialChars"] = "contains_special_chars";
      ErrorTypes["empty"] = "empty";
      ErrorTypes["phoneNumberInvalid"] = "phone_number_invalid";
      ErrorTypes["formSubmitError"] = "form_error";
      ErrorTypes["TAKEN"] = "email_taken";
      ErrorTypes["maxDate"] = "max_date";
      ErrorTypes["invalidDate"] = "invalid_date";
      ErrorTypes["invalidEmail"] = "invalid_email";
    })(ErrorTypes || (ErrorTypes = {}));

    const MUTATION_CUSTOMER_CREATE = `#graphql
	mutation customerCreate($input: CustomerCreateInput!) {
		customerCreate(input: $input) {
			customer {
				id
				email
			}
			customerUserErrors {
				field
				message
				code
			}
		}
	}
`;
    const mutationCustomerCreate = async ({
      input
    }, token) => {
      if (input.phone === '') delete input.phone;
      const acceptLanguage = `${window?.Shopify?.locale}, ${window?.Shopify?.locale}-${window?.Shopify?.country}` || 'en';
      const response = await fetch(API_STOREFRONT, {
        method: 'POST',
        headers: {
          'X-Shopify-Storefront-Access-Token': token,
          'Content-Type': 'application/json',
          'Accept-Language': acceptLanguage
        },
        body: JSON.stringify({
          query: MUTATION_CUSTOMER_CREATE,
          variables: {
            input
          }
        })
      });
      return await response.json();
    };

    const {
      dispatchCartError,
      cartErrorMessage
    } = window.PoleneLibs.CartEvents;
    const getCartToken = async () => {
      const root = ROOT_PATH;
      try {
        const response = await fetch(`${root}cart.js`);
        if (!response.ok) {
          dispatchCartError({
            endpoint: 'cart.js',
            method: 'GET',
            status: response.status,
            message: `HTTP ${response.status}`
          });
          return null;
        }
        const cart = await response.json();
        return typeof cart?.token === 'string' ? cart.token.split('?')[0] : null;
      } catch (error) {
        dispatchCartError({
          endpoint: 'cart.js',
          method: 'GET',
          status: null,
          message: cartErrorMessage(error)
        });
        return null;
      }
    };

    const {
      dispatchEvent: dispatchEvent$1,
      getClientToken: getClientToken$1
    } = window.PoleneLibs.Utils;
    const events$1 = window.PoleneLibs.Events.default;
    const {
      storeLanguage: storeLanguage$1
    } = window.PoleneLibs.ConstantsDate;
    const handleCreateCustomer = async (formData, storeFrontToken) => {
      let customerIsCreated = true;
      let errorType = ErrorTypes.formSubmitError;
      let errorMessage;
      let customerId;
      try {
        const customerCreate = await mutationCustomerCreate({
          input: {
            firstName: formData.get('firstName'),
            lastName: formData.get('lastName'),
            email: formData.get('email'),
            phone: formData.get('phone'),
            password: formData.get('password'),
            acceptsMarketing: true
          }
        }, storeFrontToken);
        if (customerCreate && 'data' in customerCreate) {
          const userErrors = customerCreate?.data?.customerCreate?.customerUserErrors;
          if (userErrors?.length !== 0) {
            customerIsCreated = false;
            userErrors?.forEach(error => {
              if (error.field?.includes('email') && error.code === 'TAKEN') {
                errorType = ErrorTypes.TAKEN;
              } else {
                errorMessage = error.message;
              }
            });
          } else if (customerCreate?.data?.customerCreate?.customer && customerCreate.data.customerCreate) {
            customerId = customerCreate.data.customerCreate.customer.id;
            if (customerId) {
              formData.append('customerId', customerId);
              formData.append('name', 'registerCustomer');
              formData.set('locale', storeLanguage$1);
              const clientToken = getClientToken$1();
              if (clientToken) formData.set('client_token', clientToken);
              const cartToken = await getCartToken();
              if (cartToken) formData.set('cart_token', cartToken);
              const response = await fetch(API_PROXY.CREATE_CUSTOMER, {
                method: 'POST',
                body: formData
              });
              dispatchEvent$1(window, events$1.NEWSLETTER_SUBSCRIBED, {
                detail: {
                  source: 'register'
                }
              });
              dispatchEvent$1(window, 'CUSTOMER_REGISTERED', {
                email: formData.get('email')?.toString() || '',
                firstName: formData.get('firstName')?.toString() || '',
                lastName: formData.get('lastName')?.toString() || '',
                customerId: customerId?.replace('gid://shopify/Customer/', '')
              });
              const responseJSON = await response.json();
              const redirect_url = responseJSON?.token ? `${REDIRECT_URL.LOGIN_MULTI_PASS}/${responseJSON?.token}` : `${REDIRECT_URL.LOGIN}`;
              window.location.replace(redirect_url);
            }
          }
        }
        if (customerCreate && 'errors' in customerCreate && customerCreate.errors && customerCreate.errors.length !== 0) {
          customerIsCreated = false;
          errorMessage = customerCreate.errors[0].message;
        }
      } catch (error) {
        customerIsCreated = false;
      }
      return {
        customerIsCreated,
        errorType,
        errorMessage,
        customerId
      };
    };

    var metadata = {
      "version": 4,
      "country_calling_codes": {
        "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"],
        "7": ["RU", "KZ"],
        "20": ["EG"],
        "27": ["ZA"],
        "30": ["GR"],
        "31": ["NL"],
        "32": ["BE"],
        "33": ["FR"],
        "34": ["ES"],
        "36": ["HU"],
        "39": ["IT", "VA"],
        "40": ["RO"],
        "41": ["CH"],
        "43": ["AT"],
        "44": ["GB", "GG", "IM", "JE"],
        "45": ["DK"],
        "46": ["SE"],
        "47": ["NO", "SJ"],
        "48": ["PL"],
        "49": ["DE"],
        "51": ["PE"],
        "52": ["MX"],
        "53": ["CU"],
        "54": ["AR"],
        "55": ["BR"],
        "56": ["CL"],
        "57": ["CO"],
        "58": ["VE"],
        "60": ["MY"],
        "61": ["AU", "CC", "CX"],
        "62": ["ID"],
        "63": ["PH"],
        "64": ["NZ"],
        "65": ["SG"],
        "66": ["TH"],
        "81": ["JP"],
        "82": ["KR"],
        "84": ["VN"],
        "86": ["CN"],
        "90": ["TR"],
        "91": ["IN"],
        "92": ["PK"],
        "93": ["AF"],
        "94": ["LK"],
        "95": ["MM"],
        "98": ["IR"],
        "211": ["SS"],
        "212": ["MA", "EH"],
        "213": ["DZ"],
        "216": ["TN"],
        "218": ["LY"],
        "220": ["GM"],
        "221": ["SN"],
        "222": ["MR"],
        "223": ["ML"],
        "224": ["GN"],
        "225": ["CI"],
        "226": ["BF"],
        "227": ["NE"],
        "228": ["TG"],
        "229": ["BJ"],
        "230": ["MU"],
        "231": ["LR"],
        "232": ["SL"],
        "233": ["GH"],
        "234": ["NG"],
        "235": ["TD"],
        "236": ["CF"],
        "237": ["CM"],
        "238": ["CV"],
        "239": ["ST"],
        "240": ["GQ"],
        "241": ["GA"],
        "242": ["CG"],
        "243": ["CD"],
        "244": ["AO"],
        "245": ["GW"],
        "246": ["IO"],
        "247": ["AC"],
        "248": ["SC"],
        "249": ["SD"],
        "250": ["RW"],
        "251": ["ET"],
        "252": ["SO"],
        "253": ["DJ"],
        "254": ["KE"],
        "255": ["TZ"],
        "256": ["UG"],
        "257": ["BI"],
        "258": ["MZ"],
        "260": ["ZM"],
        "261": ["MG"],
        "262": ["RE", "YT"],
        "263": ["ZW"],
        "264": ["NA"],
        "265": ["MW"],
        "266": ["LS"],
        "267": ["BW"],
        "268": ["SZ"],
        "269": ["KM"],
        "290": ["SH", "TA"],
        "291": ["ER"],
        "297": ["AW"],
        "298": ["FO"],
        "299": ["GL"],
        "350": ["GI"],
        "351": ["PT"],
        "352": ["LU"],
        "353": ["IE"],
        "354": ["IS"],
        "355": ["AL"],
        "356": ["MT"],
        "357": ["CY"],
        "358": ["FI", "AX"],
        "359": ["BG"],
        "370": ["LT"],
        "371": ["LV"],
        "372": ["EE"],
        "373": ["MD"],
        "374": ["AM"],
        "375": ["BY"],
        "376": ["AD"],
        "377": ["MC"],
        "378": ["SM"],
        "380": ["UA"],
        "381": ["RS"],
        "382": ["ME"],
        "383": ["XK"],
        "385": ["HR"],
        "386": ["SI"],
        "387": ["BA"],
        "389": ["MK"],
        "420": ["CZ"],
        "421": ["SK"],
        "423": ["LI"],
        "500": ["FK"],
        "501": ["BZ"],
        "502": ["GT"],
        "503": ["SV"],
        "504": ["HN"],
        "505": ["NI"],
        "506": ["CR"],
        "507": ["PA"],
        "508": ["PM"],
        "509": ["HT"],
        "590": ["GP", "BL", "MF"],
        "591": ["BO"],
        "592": ["GY"],
        "593": ["EC"],
        "594": ["GF"],
        "595": ["PY"],
        "596": ["MQ"],
        "597": ["SR"],
        "598": ["UY"],
        "599": ["CW", "BQ"],
        "670": ["TL"],
        "672": ["NF"],
        "673": ["BN"],
        "674": ["NR"],
        "675": ["PG"],
        "676": ["TO"],
        "677": ["SB"],
        "678": ["VU"],
        "679": ["FJ"],
        "680": ["PW"],
        "681": ["WF"],
        "682": ["CK"],
        "683": ["NU"],
        "685": ["WS"],
        "686": ["KI"],
        "687": ["NC"],
        "688": ["TV"],
        "689": ["PF"],
        "690": ["TK"],
        "691": ["FM"],
        "692": ["MH"],
        "850": ["KP"],
        "852": ["HK"],
        "853": ["MO"],
        "855": ["KH"],
        "856": ["LA"],
        "880": ["BD"],
        "886": ["TW"],
        "960": ["MV"],
        "961": ["LB"],
        "962": ["JO"],
        "963": ["SY"],
        "964": ["IQ"],
        "965": ["KW"],
        "966": ["SA"],
        "967": ["YE"],
        "968": ["OM"],
        "970": ["PS"],
        "971": ["AE"],
        "972": ["IL"],
        "973": ["BH"],
        "974": ["QA"],
        "975": ["BT"],
        "976": ["MN"],
        "977": ["NP"],
        "992": ["TJ"],
        "993": ["TM"],
        "994": ["AZ"],
        "995": ["GE"],
        "996": ["KG"],
        "998": ["UZ"]
      },
      "countries": {
        "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]],
        "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]],
        "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"],
        "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"],
        "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"],
        "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"],
        "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"],
        "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"],
        "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]],
        "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"],
        "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"],
        "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"],
        "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:241|349)0\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|91(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79]))))\\d{3}|(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8])|8(?:55|6[0-8]|[78]\\d|9[02-9]))\\d{6}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
        "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]],
        "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"],
        "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"],
        "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"],
        "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"],
        "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"],
        "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"],
        "BF": ["226", "00", "(?:[025-7]\\d|44)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]]],
        "BG": ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"],
        "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]],
        "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]],
        "BJ": ["229", "00", "(?:01\\d|8)\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]],
        "BL": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],
        "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"],
        "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]],
        "BO": ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"],
        "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"],
        "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"],
        "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"],
        "BT": ["975", "00", "[178]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|[78]"]]]],
        "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]],
        "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"],
        "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]],
        "CA": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]],
        "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
        "CD": ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"],
        "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]],
        "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]],
        "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"],
        "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]],
        "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]],
        "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]],
        "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]],
        "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"],
        "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"],
        "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"],
        "CU": ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"],
        "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]],
        "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"],
        "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-36-9]|95[0-3])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
        "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]],
        "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]],
        "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"],
        "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]],
        "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]],
        "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"],
        "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"],
        "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"],
        "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"],
        "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]],
        "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"],
        "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"],
        "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"],
        "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]],
        "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"],
        "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"],
        "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
        "FK": ["500", "00", "[2-7]\\d{4}", [5]],
        "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]],
        "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"],
        "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"],
        "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"],
        "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, "0|180020", 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"],
        "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"],
        "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"],
        "GF": ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"],
        "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0|180020", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]],
        "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"],
        "GI": ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]],
        "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]],
        "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
        "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]],
        "GP": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],
        "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]],
        "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]],
        "GT": ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]],
        "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"],
        "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]],
        "GY": ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
        "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
        "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]],
        "HR": ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"],
        "HT": ["509", "00", "[2-589]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]],
        "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"],
        "ID": ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"],
        "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
        "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"],
        "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0|180020", "1624$1", 0, "74576|(?:16|7[56])24"],
        "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|8(?:28[235-7]|3))|73179|807(?:1|9[1-3])|(?:1552|6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689])\\d|8(?:[14-6]\\d|2[0-79]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"],
        "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]],
        "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"],
        "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"],
        "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
        "IT": ["39", "00", "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]], 0, 0, 0, 0, 0, 0, [["0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]],
        "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0|180020", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]],
        "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"],
        "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[47]"], "0$1"]], "0"],
        "JP": ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0", "$1"],
        "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"],
        "KG": ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
        "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
        "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"],
        "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]],
        "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"],
        "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"],
        "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"],
        "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]],
        "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"],
        "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33622|7", 0, "8~10"],
        "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"],
        "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"],
        "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"],
        "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"],
        "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"],
        "LR": ["231", "00", "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"],
        "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]],
        "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"],
        "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],
        "LV": ["371", "00", "(?:[268]\\d|78|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2679]|8[01]"]]]],
        "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"],
        "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:[19]|2[2-46-9]|3[3-9])|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:(?:18|4[0679]|5[03])\\d|2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9]))\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[016-8]\\d|2[0-8]|5[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]],
        "MC": ["377", "00", "(?:[3489]|[67]\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[67]"], "0$1"]], "0"],
        "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"],
        "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"],
        "MF": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],
        "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"],
        "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"],
        "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"],
        "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]],
        "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"],
        "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"],
        "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]],
        "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"],
        "MQ": ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
        "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]],
        "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"],
        "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]],
        "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"],
        "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
        "MW": ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"],
        "MX": ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
        "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"],
        "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]],
        "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"],
        "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]],
        "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]],
        "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"],
        "NG": ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"],
        "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]],
        "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"],
        "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"],
        "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"],
        "NR": ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]]],
        "NU": ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]],
        "NZ": ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"],
        "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]],
        "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]],
        "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "],
        "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]],
        "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
        "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"],
        "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"],
        "PL": ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]],
        "PM": ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
        "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"],
        "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
        "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]],
        "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
        "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"],
        "QA": ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]],
        "RE": ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],
        "RO": ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "],
        "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"],
        "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, 0, [["336(?:[013-9]\\d|2[013-9])\\d{5}|(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"],
        "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"],
        "SA": ["966", "00", "(?:[15]\\d|800|92)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"],
        "SB": ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],
        "SC": ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
        "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"],
        "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"],
        "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]],
        "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"],
        "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"],
        "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"],
        "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"],
        "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"],
        "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"],
        "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]],
        "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"],
        "SR": ["597", "00", "(?:[2-5]|[6-8]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]]],
        "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"],
        "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]],
        "SV": ["503", "00", "[25-7]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[25-7]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]],
        "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"],
        "SY": ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"],
        "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]],
        "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"],
        "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"],
        "TD": ["235", "00|16", "(?:22|30|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
        "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]],
        "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
        "TJ": ["992", "810", "(?:[0-57-9]\\d|66)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["\\d"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"],
        "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]],
        "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]],
        "TM": ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"],
        "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]],
        "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]],
        "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"],
        "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"],
        "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]],
        "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"],
        "TZ": ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"],
        "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"],
        "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"],
        "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["3052(?:0[0-8]|[1-9]\\d)\\d{4}|(?:2742|305[3-9])\\d{6}|(?:472|983)[2-47-9]\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]],
        "UY": ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{4,5})", "$1", ["21"]], ["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "],
        "UZ": ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]],
        "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"],
        "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"],
        "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"],
        "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"],
        "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"],
        "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"],
        "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]],
        "WF": ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]],
        "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]],
        "XK": ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"],
        "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"],
        "YT": ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],
        "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"],
        "ZM": ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"],
        "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"]
      },
      "nonGeographic": {
        "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]],
        "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]],
        "870": ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]],
        "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]],
        "881": ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]],
        "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],
        "883": ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],
        "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]],
        "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]]
      }
    };

    function withMetadataArgument(func, _arguments) {
      var args = Array.prototype.slice.call(_arguments);
      args.push(metadata);
      return func.apply(this, args);
    }

    function compare (a, b) {
      a = a.split('-');
      b = b.split('-');
      var pa = a[0].split('.');
      var pb = b[0].split('.');
      for (var i = 0; i < 3; i++) {
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
      }
      if (a[1] && b[1]) {
        return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
      }
      return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
    }

    var objectConstructor = {}.constructor;
    function isObject(object) {
      return object !== undefined && object !== null && object.constructor === objectConstructor;
    }

    function _typeof$6(o) {
      "@babel/helpers - typeof";

      return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, _typeof$6(o);
    }
    function _classCallCheck$2(a, n) {
      if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties$2(e, r) {
      for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey$6(o.key), o);
      }
    }
    function _createClass$2(e, r, t) {
      return r && _defineProperties$2(e.prototype, r), t && _defineProperties$2(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }
    function _toPropertyKey$6(t) {
      var i = _toPrimitive$6(t, "string");
      return "symbol" == _typeof$6(i) ? i : i + "";
    }
    function _toPrimitive$6(t, r) {
      if ("object" != _typeof$6(t) || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof$6(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    var V3 = '1.2.0';
    var V4 = '1.7.35';
    var DEFAULT_EXT_PREFIX = ' ext. ';
    var CALLING_CODE_REG_EXP = /^\d+$/;
    var Metadata = function () {
      function Metadata(metadata) {
        _classCallCheck$2(this, Metadata);
        validateMetadata(metadata);
        this.metadata = metadata;
        setVersion.call(this, metadata);
      }
      return _createClass$2(Metadata, [{
        key: "getCountries",
        value: function getCountries() {
          return Object.keys(this.metadata.countries).filter(function (_) {
            return _ !== '001';
          });
        }
      }, {
        key: "getCountryMetadata",
        value: function getCountryMetadata(countryCode) {
          return this.metadata.countries[countryCode];
        }
      }, {
        key: "nonGeographic",
        value: function nonGeographic() {
          if (this.v1 || this.v2 || this.v3) return;
          return this.metadata.nonGeographic || this.metadata.nonGeographical;
        }
      }, {
        key: "hasCountry",
        value: function hasCountry(country) {
          return this.getCountryMetadata(country) !== undefined;
        }
      }, {
        key: "hasCallingCode",
        value: function hasCallingCode(callingCode) {
          if (this.getCountryCodesForCallingCode(callingCode)) {
            return true;
          }
          if (this.nonGeographic()) {
            if (this.nonGeographic()[callingCode]) {
              return true;
            }
          } else {
            var countryCodes = this.countryCallingCodes()[callingCode];
            if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
              return true;
            }
          }
        }
      }, {
        key: "isNonGeographicCallingCode",
        value: function isNonGeographicCallingCode(callingCode) {
          if (this.nonGeographic()) {
            return this.nonGeographic()[callingCode] ? true : false;
          } else {
            return this.getCountryCodesForCallingCode(callingCode) ? false : true;
          }
        }
      }, {
        key: "country",
        value: function country(countryCode) {
          return this.selectNumberingPlan(countryCode);
        }
      }, {
        key: "selectNumberingPlan",
        value: function selectNumberingPlan(countryCode, callingCode) {
          if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
            callingCode = countryCode;
            countryCode = null;
          }
          if (countryCode && countryCode !== '001') {
            if (!this.hasCountry(countryCode)) {
              throw new Error("Unknown country: ".concat(countryCode));
            }
            this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
          } else if (callingCode) {
            if (!this.hasCallingCode(callingCode)) {
              throw new Error("Unknown calling code: ".concat(callingCode));
            }
            this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
          } else {
            this.numberingPlan = undefined;
          }
          return this;
        }
      }, {
        key: "getCountryCodesForCallingCode",
        value: function getCountryCodesForCallingCode(callingCode) {
          var countryCodes = this.countryCallingCodes()[callingCode];
          if (countryCodes) {
            if (countryCodes.length === 1 && countryCodes[0].length === 3) {
              return;
            }
            return countryCodes;
          }
        }
      }, {
        key: "getCountryCodeForCallingCode",
        value: function getCountryCodeForCallingCode(callingCode) {
          var countryCodes = this.getCountryCodesForCallingCode(callingCode);
          if (countryCodes) {
            return countryCodes[0];
          }
        }
      }, {
        key: "getNumberingPlanMetadata",
        value: function getNumberingPlanMetadata(callingCode) {
          var countryCode = this.getCountryCodeForCallingCode(callingCode);
          if (countryCode) {
            return this.getCountryMetadata(countryCode);
          }
          if (this.nonGeographic()) {
            var metadata = this.nonGeographic()[callingCode];
            if (metadata) {
              return metadata;
            }
          } else {
            var countryCodes = this.countryCallingCodes()[callingCode];
            if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
              return this.metadata.countries['001'];
            }
          }
        }
      }, {
        key: "countryCallingCode",
        value: function countryCallingCode() {
          return this.numberingPlan.callingCode();
        }
      }, {
        key: "IDDPrefix",
        value: function IDDPrefix() {
          return this.numberingPlan.IDDPrefix();
        }
      }, {
        key: "defaultIDDPrefix",
        value: function defaultIDDPrefix() {
          return this.numberingPlan.defaultIDDPrefix();
        }
      }, {
        key: "nationalNumberPattern",
        value: function nationalNumberPattern() {
          return this.numberingPlan.nationalNumberPattern();
        }
      }, {
        key: "possibleLengths",
        value: function possibleLengths() {
          return this.numberingPlan.possibleLengths();
        }
      }, {
        key: "formats",
        value: function formats() {
          return this.numberingPlan.formats();
        }
      }, {
        key: "nationalPrefixForParsing",
        value: function nationalPrefixForParsing() {
          return this.numberingPlan.nationalPrefixForParsing();
        }
      }, {
        key: "nationalPrefixTransformRule",
        value: function nationalPrefixTransformRule() {
          return this.numberingPlan.nationalPrefixTransformRule();
        }
      }, {
        key: "leadingDigits",
        value: function leadingDigits() {
          return this.numberingPlan.leadingDigits();
        }
      }, {
        key: "hasTypes",
        value: function hasTypes() {
          return this.numberingPlan.hasTypes();
        }
      }, {
        key: "type",
        value: function type(_type) {
          return this.numberingPlan.type(_type);
        }
      }, {
        key: "ext",
        value: function ext() {
          return this.numberingPlan.ext();
        }
      }, {
        key: "countryCallingCodes",
        value: function countryCallingCodes() {
          if (this.v1) return this.metadata.country_phone_code_to_countries;
          return this.metadata.country_calling_codes;
        }
      }, {
        key: "chooseCountryByCountryCallingCode",
        value: function chooseCountryByCountryCallingCode(callingCode) {
          return this.selectNumberingPlan(callingCode);
        }
      }, {
        key: "hasSelectedNumberingPlan",
        value: function hasSelectedNumberingPlan() {
          return this.numberingPlan !== undefined;
        }
      }]);
    }();
    var NumberingPlan = function () {
      function NumberingPlan(metadata, globalMetadataObject) {
        _classCallCheck$2(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        setVersion.call(this, globalMetadataObject.metadata);
      }
      return _createClass$2(NumberingPlan, [{
        key: "callingCode",
        value: function callingCode() {
          return this.metadata[0];
        }
      }, {
        key: "getDefaultCountryMetadataForRegion",
        value: function getDefaultCountryMetadataForRegion() {
          return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
        }
      }, {
        key: "IDDPrefix",
        value: function IDDPrefix() {
          if (this.v1 || this.v2) return;
          return this.metadata[1];
        }
      }, {
        key: "defaultIDDPrefix",
        value: function defaultIDDPrefix() {
          if (this.v1 || this.v2) return;
          return this.metadata[12];
        }
      }, {
        key: "nationalNumberPattern",
        value: function nationalNumberPattern() {
          if (this.v1 || this.v2) return this.metadata[1];
          return this.metadata[2];
        }
      }, {
        key: "possibleLengths",
        value: function possibleLengths() {
          if (this.v1) return;
          return this.metadata[this.v2 ? 2 : 3];
        }
      }, {
        key: "_getFormats",
        value: function _getFormats(metadata) {
          return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
        }
      }, {
        key: "formats",
        value: function formats() {
          var _this = this;
          var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
          return formats.map(function (_) {
            return new Format(_, _this);
          });
        }
      }, {
        key: "nationalPrefix",
        value: function nationalPrefix() {
          return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
        }
      }, {
        key: "_getNationalPrefixFormattingRule",
        value: function _getNationalPrefixFormattingRule(metadata) {
          return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
        }
      }, {
        key: "nationalPrefixFormattingRule",
        value: function nationalPrefixFormattingRule() {
          return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
        }
      }, {
        key: "_nationalPrefixForParsing",
        value: function _nationalPrefixForParsing() {
          return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
        }
      }, {
        key: "nationalPrefixForParsing",
        value: function nationalPrefixForParsing() {
          return this._nationalPrefixForParsing() || this.nationalPrefix();
        }
      }, {
        key: "nationalPrefixTransformRule",
        value: function nationalPrefixTransformRule() {
          return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
        }
      }, {
        key: "_getNationalPrefixIsOptionalWhenFormatting",
        value: function _getNationalPrefixIsOptionalWhenFormatting() {
          return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
        }
      }, {
        key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
        value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
          return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
        }
      }, {
        key: "leadingDigits",
        value: function leadingDigits() {
          return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
        }
      }, {
        key: "types",
        value: function types() {
          return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
        }
      }, {
        key: "hasTypes",
        value: function hasTypes() {
          if (this.types() && this.types().length === 0) {
            return false;
          }
          return !!this.types();
        }
      }, {
        key: "type",
        value: function type(_type2) {
          if (this.hasTypes() && getType(this.types(), _type2)) {
            return new Type(getType(this.types(), _type2), this);
          }
        }
      }, {
        key: "ext",
        value: function ext() {
          if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
          return this.metadata[13] || DEFAULT_EXT_PREFIX;
        }
      }]);
    }();
    var Format = function () {
      function Format(format, metadata) {
        _classCallCheck$2(this, Format);
        this._format = format;
        this.metadata = metadata;
      }
      return _createClass$2(Format, [{
        key: "pattern",
        value: function pattern() {
          return this._format[0];
        }
      }, {
        key: "format",
        value: function format() {
          return this._format[1];
        }
      }, {
        key: "leadingDigitsPatterns",
        value: function leadingDigitsPatterns() {
          return this._format[2] || [];
        }
      }, {
        key: "nationalPrefixFormattingRule",
        value: function nationalPrefixFormattingRule() {
          return this._format[3] || this.metadata.nationalPrefixFormattingRule();
        }
      }, {
        key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
        value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
          return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
        }
      }, {
        key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
        value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
          return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
        }
      }, {
        key: "usesNationalPrefix",
        value: function usesNationalPrefix() {
          return this.nationalPrefixFormattingRule() && !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
        }
      }, {
        key: "internationalFormat",
        value: function internationalFormat() {
          return this._format[5] || this.format();
        }
      }]);
    }();
    var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
    var Type = function () {
      function Type(type, metadata) {
        _classCallCheck$2(this, Type);
        this.type = type;
        this.metadata = metadata;
      }
      return _createClass$2(Type, [{
        key: "pattern",
        value: function pattern() {
          if (this.metadata.v1) return this.type;
          return this.type[0];
        }
      }, {
        key: "possibleLengths",
        value: function possibleLengths() {
          if (this.metadata.v1) return;
          return this.type[1] || this.metadata.possibleLengths();
        }
      }]);
    }();
    function getType(types, type) {
      switch (type) {
        case 'FIXED_LINE':
          return types[0];
        case 'MOBILE':
          return types[1];
        case 'TOLL_FREE':
          return types[2];
        case 'PREMIUM_RATE':
          return types[3];
        case 'PERSONAL_NUMBER':
          return types[4];
        case 'VOICEMAIL':
          return types[5];
        case 'UAN':
          return types[6];
        case 'PAGER':
          return types[7];
        case 'VOIP':
          return types[8];
        case 'SHARED_COST':
          return types[9];
      }
    }
    function validateMetadata(metadata) {
      if (!metadata) {
        throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
      }
      if (!isObject(metadata) || !isObject(metadata.countries)) {
        throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + typeOf(metadata) + ': ' + metadata, "."));
      }
    }
    var typeOf = function typeOf(_) {
      return _typeof$6(_);
    };
    function getCountryCallingCode$1(country, metadata) {
      metadata = new Metadata(metadata);
      if (metadata.hasCountry(country)) {
        return metadata.selectNumberingPlan(country).countryCallingCode();
      }
      throw new Error("Unknown country: ".concat(country));
    }
    function isSupportedCountry$1(country, metadata) {
      return metadata.countries.hasOwnProperty(country);
    }
    function setVersion(metadata) {
      var version = metadata.version;
      if (typeof version === 'number') {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
      } else {
        if (!version) {
          this.v1 = true;
        } else if (compare(version, V3) === -1) {
          this.v2 = true;
        } else if (compare(version, V4) === -1) {
          this.v3 = true;
        } else {
          this.v4 = true;
        }
      }
    }

    function _createForOfIteratorHelperLoose$3(r, e) {
      var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (t) return (t = t.call(r)).next.bind(t);
      if (Array.isArray(r) || (t = _unsupportedIterableToArray$4(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function () {
          return o >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[o++]
          };
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray$4(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray$4(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$4(r, a) : void 0;
      }
    }
    function _arrayLikeToArray$4(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function mergeArrays(a, b) {
      var merged = a.slice();
      for (var _iterator = _createForOfIteratorHelperLoose$3(b), _step; !(_step = _iterator()).done;) {
        var element = _step.value;
        if (a.indexOf(element) < 0) {
          merged.push(element);
        }
      }
      return merged.sort(function (a, b) {
        return a - b;
      });
    }

    function checkNumberLength(nationalNumber, country, metadata) {
      return checkNumberLengthForType(nationalNumber, country, undefined, metadata);
    }
    function checkNumberLengthForType(nationalNumber, country, type, metadata) {
      if (country) {
        metadata = new Metadata(metadata.metadata);
        metadata.selectNumberingPlan(country);
      }
      var type_info = metadata.type(type);
      var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths();
      if (!possible_lengths) {
        return 'IS_POSSIBLE';
      }
      if (type === 'FIXED_LINE_OR_MOBILE') {
        if (!metadata.type('FIXED_LINE')) {
          return checkNumberLengthForType(nationalNumber, country, 'MOBILE', metadata);
        }
        var mobile_type = metadata.type('MOBILE');
        if (mobile_type) {
          possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths());
        }
      } else if (type && !type_info) {
        return 'INVALID_LENGTH';
      }
      var actual_length = nationalNumber.length;
      var minimum_length = possible_lengths[0];
      if (minimum_length === actual_length) {
        return 'IS_POSSIBLE';
      }
      if (minimum_length > actual_length) {
        return 'TOO_SHORT';
      }
      if (possible_lengths[possible_lengths.length - 1] < actual_length) {
        return 'TOO_LONG';
      }
      return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
    }

    function isPossiblePhoneNumber(input, options, metadata) {
      if (options === undefined) {
        options = {};
      }
      metadata = new Metadata(metadata);
      if (options.v2) {
        if (!input.countryCallingCode) {
          throw new Error('Invalid phone number object passed');
        }
        metadata.selectNumberingPlan(input.countryCallingCode);
      } else {
        if (!input.phone) {
          return false;
        }
        if (input.country) {
          if (!metadata.hasCountry(input.country)) {
            throw new Error("Unknown country: ".concat(input.country));
          }
          metadata.selectNumberingPlan(input.country);
        } else {
          if (!input.countryCallingCode) {
            throw new Error('Invalid phone number object passed');
          }
          metadata.selectNumberingPlan(input.countryCallingCode);
        }
      }
      if (metadata.possibleLengths()) {
        return isPossibleNumber(input.phone || input.nationalNumber, input.country, metadata);
      } else {
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
          return true;
        } else {
          throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
        }
      }
    }
    function isPossibleNumber(nationalNumber, country, metadata) {
      switch (checkNumberLength(nationalNumber, country, metadata)) {
        case 'IS_POSSIBLE':
          return true;
        default:
          return false;
      }
    }

    function matchesEntirely(text, regularExpressionText) {
      text = text || '';
      return new RegExp('^(?:' + regularExpressionText + ')$').test(text);
    }

    function _createForOfIteratorHelperLoose$2(r, e) {
      var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (t) return (t = t.call(r)).next.bind(t);
      if (Array.isArray(r) || (t = _unsupportedIterableToArray$3(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function () {
          return o >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[o++]
          };
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray$3(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray$3(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$3(r, a) : void 0;
      }
    }
    function _arrayLikeToArray$3(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL'];
    function getNumberType(input, options, metadata) {
      options = options || {};
      if (!input.country && !input.countryCallingCode) {
        return;
      }
      metadata = new Metadata(metadata);
      metadata.selectNumberingPlan(input.country, input.countryCallingCode);
      var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
      if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
        return;
      }
      if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
        if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
          return 'FIXED_LINE_OR_MOBILE';
        }
        if (!metadata.type('MOBILE')) {
          return 'FIXED_LINE_OR_MOBILE';
        }
        if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
          return 'FIXED_LINE_OR_MOBILE';
        }
        return 'FIXED_LINE';
      }
      for (var _iterator = _createForOfIteratorHelperLoose$2(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
        var type = _step.value;
        if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
          return type;
        }
      }
    }
    function isNumberTypeEqualTo(nationalNumber, type, metadata) {
      type = metadata.type(type);
      if (!type || !type.pattern()) {
        return false;
      }
      if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
        return false;
      }
      return matchesEntirely(nationalNumber, type.pattern());
    }

    function isValidNumber(input, options, metadata) {
      options = options || {};
      metadata = new Metadata(metadata);
      metadata.selectNumberingPlan(input.country, input.countryCallingCode);
      if (metadata.hasTypes()) {
        return getNumberType(input, options, metadata.metadata) !== undefined;
      }
      var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
      return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
    }

    function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
      var _metadata = new Metadata(metadata);
      var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
      if (!possibleCountries) {
        return [];
      }
      return possibleCountries.filter(function (country) {
        return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
      });
    }
    function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
      var _metadata = new Metadata(metadata);
      _metadata.selectNumberingPlan(country);
      if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
        return true;
      }
      return false;
    }

    var MIN_LENGTH_FOR_NSN = 2;
    var MAX_LENGTH_FOR_NSN = 17;
    var MAX_LENGTH_COUNTRY_CODE = 3;
    var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
    var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
    var SLASHES = "\uFF0F/";
    var DOTS = "\uFF0E.";
    var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
    var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
    var TILDES = "~\u2053\u223C\uFF5E";
    var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
    var PLUS_CHARS = "+\uFF0B";

    var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
    function stripIddPrefix(number, country, callingCode, metadata) {
      if (!country) {
        return;
      }
      var countryMetadata = new Metadata(metadata);
      countryMetadata.selectNumberingPlan(country, callingCode);
      var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
      if (number.search(IDDPrefixPattern) !== 0) {
        return;
      }
      number = number.slice(number.match(IDDPrefixPattern)[0].length);
      var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
      if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === '0') {
          return;
        }
      }
      return number;
    }

    function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
      if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
          var nationalNumber;
          var carrierCode;
          var capturedGroupsCount = prefixMatch.length - 1;
          var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
          if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
            nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule());
            if (capturedGroupsCount > 1) {
              carrierCode = prefixMatch[1];
            }
          } else {
            var prefixBeforeNationalNumber = prefixMatch[0];
            nationalNumber = number.slice(prefixBeforeNationalNumber.length);
            if (hasCapturedGroups) {
              carrierCode = prefixMatch[1];
            }
          }
          var nationalPrefix;
          if (hasCapturedGroups) {
            var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
            var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup);
            if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
              nationalPrefix = metadata.numberingPlan.nationalPrefix();
            }
          } else {
            nationalPrefix = prefixMatch[0];
          }
          return {
            nationalNumber: nationalNumber,
            nationalPrefix: nationalPrefix,
            carrierCode: carrierCode
          };
        }
      }
      return {
        nationalNumber: number
      };
    }

    function _createForOfIteratorHelperLoose$1(r, e) {
      var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (t) return (t = t.call(r)).next.bind(t);
      if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function () {
          return o >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[o++]
          };
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray$2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray$2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0;
      }
    }
    function _arrayLikeToArray$2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
      var countries = _ref.countries,
        metadata = _ref.metadata;
      metadata = new Metadata(metadata);
      for (var _iterator = _createForOfIteratorHelperLoose$1(countries), _step; !(_step = _iterator()).done;) {
        var country = _step.value;
        metadata.selectNumberingPlan(country);
        if (metadata.leadingDigits()) {
          if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
            return country;
          }
        } else if (getNumberType({
          phone: nationalPhoneNumber,
          country: country
        }, undefined, metadata.metadata)) {
          return country;
        }
      }
    }

    var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
    function getCountryByCallingCode(callingCode, _ref) {
      var nationalPhoneNumber = _ref.nationalNumber,
        metadata = _ref.metadata;
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) {
          return '001';
        }
      }
      var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
      if (!possibleCountries) {
        return;
      }
      if (possibleCountries.length === 1) {
        return possibleCountries[0];
      }
      return getCountryByNationalNumber(nationalPhoneNumber, {
        countries: possibleCountries,
        metadata: metadata.metadata
      });
    }

    function extractNationalNumber(number, country, metadata) {
      var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
        carrierCode = _extractNationalNumbe.carrierCode,
        nationalNumber = _extractNationalNumbe.nationalNumber;
      if (nationalNumber !== number) {
        if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
          return {
            nationalNumber: number
          };
        }
        if (metadata.numberingPlan.possibleLengths()) {
          if (!country) {
            country = getCountryByCallingCode(metadata.numberingPlan.callingCode(), {
              nationalNumber: nationalNumber,
              metadata: metadata
            });
          }
          if (!isPossibleIncompleteNationalNumber(nationalNumber, country, metadata)) {
            return {
              nationalNumber: number
            };
          }
        }
      }
      return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
      };
    }
    function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
      if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
        return false;
      }
      return true;
    }
    function isPossibleIncompleteNationalNumber(nationalNumber, country, metadata) {
      switch (checkNumberLength(nationalNumber, country, metadata)) {
        case 'TOO_SHORT':
        case 'INVALID_LENGTH':
          return false;
        default:
          return true;
      }
    }

    function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, defaultCountry, defaultCallingCode, metadata) {
      var countryCallingCode = country || defaultCountry ? getCountryCallingCode$1(country || defaultCountry, metadata) : defaultCallingCode;
      if (number.indexOf(countryCallingCode) === 0) {
        metadata = new Metadata(metadata);
        metadata.selectNumberingPlan(country || defaultCountry, countryCallingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, country, metadata),
          possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = extractNationalNumber(number, country, metadata),
          nationalNumber = _extractNationalNumbe2.nationalNumber;
        if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, country, metadata) === 'TOO_LONG') {
          return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
          };
        }
      }
      return {
        number: number
      };
    }

    function extractCountryCallingCode(number, country, defaultCountry, defaultCallingCode, metadata) {
      if (!number) {
        return {};
      }
      var isNumberWithIddPrefix;
      if (number[0] !== '+') {
        var numberWithoutIDD = stripIddPrefix(number, country || defaultCountry, defaultCallingCode, metadata);
        if (numberWithoutIDD && numberWithoutIDD !== number) {
          isNumberWithIddPrefix = true;
          number = '+' + numberWithoutIDD;
        } else {
          if (country || defaultCountry || defaultCallingCode) {
            var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, defaultCountry, defaultCallingCode, metadata),
              countryCallingCode = _extractCountryCallin.countryCallingCode,
              shorterNumber = _extractCountryCallin.number;
            if (countryCallingCode) {
              return {
                countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
                countryCallingCode: countryCallingCode,
                number: shorterNumber
              };
            }
          }
          return {
            number: number
          };
        }
      }
      if (number[1] === '0') {
        return {};
      }
      metadata = new Metadata(metadata);
      var i = 2;
      while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
          metadata.selectNumberingPlan(_countryCallingCode);
          return {
            countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
            countryCallingCode: _countryCallingCode,
            number: number.slice(i)
          };
        }
        i++;
      }
      return {};
    }

    function applyInternationalSeparatorStyle(formattedNumber) {
      return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
    }

    var FIRST_GROUP_PATTERN = /(\$\d)/;
    function formatNationalNumberUsingFormat(number, format, _ref) {
      var useInternationalFormat = _ref.useInternationalFormat,
        withNationalPrefix = _ref.withNationalPrefix;
        _ref.carrierCode;
        _ref.metadata;
      var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());
      if (useInternationalFormat) {
        return applyInternationalSeparatorStyle(formattedNumber);
      }
      return formattedNumber;
    }

    var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
    function getIddPrefix(country, callingCode, metadata) {
      var countryMetadata = new Metadata(metadata);
      countryMetadata.selectNumberingPlan(country, callingCode);
      if (countryMetadata.defaultIDDPrefix()) {
        return countryMetadata.defaultIDDPrefix();
      }
      if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
        return countryMetadata.IDDPrefix();
      }
    }

    var RFC3966_EXTN_PREFIX = ';ext=';
    var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
      return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
    };
    function createExtensionPattern(purpose) {
      var extLimitAfterExplicitLabel = '20';
      var extLimitAfterLikelyLabel = '15';
      var extLimitAfterAmbiguousChar = '9';
      var extLimitWhenNotSure = '6';
      var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
      var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
      var optionalExtnSuffix = "#?";
      var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
      var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
      var ambiguousSeparator = "[- ]+";
      var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
      var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
      var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
      var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
      var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
      var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
      var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
      var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
      return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
    }

    var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}';
    var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*';
    var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
    var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + '(?:' + createExtensionPattern() + ')?';
    var VALID_PHONE_NUMBER_PATTERN = new RegExp('^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + '^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i');
    function isViablePhoneNumber(number) {
      return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
    }
    function isViablePhoneNumberStart(number) {
      return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
    }

    function formatRFC3966(_ref) {
      var number = _ref.number,
        ext = _ref.ext;
      if (!number) {
        return '';
      }
      if (number[0] !== '+') {
        throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
      }
      return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
    }

    var DEFAULT_OPTIONS = {
      formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
      }
    };
    function formatNumber(input, format, options, metadata) {
      if (options) {
        options = merge({}, DEFAULT_OPTIONS, options);
      } else {
        options = DEFAULT_OPTIONS;
      }
      metadata = new Metadata(metadata);
      if (input.country && input.country !== '001') {
        if (!metadata.hasCountry(input.country)) {
          throw new Error("Unknown country: ".concat(input.country));
        }
        metadata.selectNumberingPlan(input.country);
      } else if (input.countryCallingCode) {
        metadata.selectNumberingPlan(input.countryCallingCode);
      } else return input.phone || '';
      var countryCallingCode = metadata.countryCallingCode();
      var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
      var number;
      switch (format) {
        case 'NATIONAL':
          if (!nationalNumber) {
            return '';
          }
          number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
          return addExtension(number, input.ext, metadata, options.formatExtension);
        case 'INTERNATIONAL':
          if (!nationalNumber) {
            return "+".concat(countryCallingCode);
          }
          number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
          number = "+".concat(countryCallingCode, " ").concat(number);
          return addExtension(number, input.ext, metadata, options.formatExtension);
        case 'E.164':
          return "+".concat(countryCallingCode).concat(nationalNumber);
        case 'RFC3966':
          return formatRFC3966({
            number: "+".concat(countryCallingCode).concat(nationalNumber),
            ext: input.ext
          });
        case 'IDD':
          if (!options.fromCountry) {
            return;
          }
          var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
          return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
          throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
      }
    }
    function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
      var format = chooseFormatForNumber(metadata.formats(), number);
      if (!format) {
        return number;
      }
      return formatNationalNumberUsingFormat(number, format, {
        useInternationalFormat: formatAs === 'INTERNATIONAL',
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
      });
    }
    function chooseFormatForNumber(availableFormats, nationalNumber) {
      return pickFirstMatchingElement(availableFormats, function (format) {
        if (format.leadingDigitsPatterns().length > 0) {
          var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
          if (nationalNumber.search(lastLeadingDigitsPattern) !== 0) {
            return false;
          }
        }
        return matchesEntirely(nationalNumber, format.pattern());
      });
    }
    function addExtension(formattedNumber, ext, metadata, formatExtension) {
      return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
    }
    function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
      var fromCountryCallingCode = getCountryCallingCode$1(fromCountry, metadata.metadata);
      if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata);
        if (countryCallingCode === '1') {
          return countryCallingCode + ' ' + formattedNumber;
        }
        return formattedNumber;
      }
      var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);
      if (iddPrefix) {
        return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
      }
    }
    function merge() {
      var i = 1;
      for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
        objects[_key] = arguments[_key];
      }
      while (i < objects.length) {
        if (objects[i]) {
          for (var key in objects[i]) {
            objects[0][key] = objects[i][key];
          }
        }
        i++;
      }
      return objects[0];
    }
    function pickFirstMatchingElement(elements, testFunction) {
      var i = 0;
      while (i < elements.length) {
        if (testFunction(elements[i])) {
          return elements[i];
        }
        i++;
      }
    }

    function _typeof$5(o) {
      "@babel/helpers - typeof";

      return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, _typeof$5(o);
    }
    function ownKeys$4(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread$4(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) {
          _defineProperty$4(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
      }
      return e;
    }
    function _defineProperty$4(e, r, t) {
      return (r = _toPropertyKey$5(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }
    function _classCallCheck$1(a, n) {
      if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties$1(e, r) {
      for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey$5(o.key), o);
      }
    }
    function _createClass$1(e, r, t) {
      return r && _defineProperties$1(e.prototype, r), t && _defineProperties$1(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }
    function _toPropertyKey$5(t) {
      var i = _toPrimitive$5(t, "string");
      return "symbol" == _typeof$5(i) ? i : i + "";
    }
    function _toPrimitive$5(t, r) {
      if ("object" != _typeof$5(t) || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof$5(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    var PhoneNumber = function () {
      function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        _classCallCheck$1(this, PhoneNumber);
        if (!countryOrCountryCallingCode) {
          throw new TypeError('First argument is required');
        }
        if (typeof countryOrCountryCallingCode !== 'string') {
          throw new TypeError('First argument must be a string');
        }
        if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) {
          throw new TypeError('`metadata` argument not passed');
        }
        if (isObject(nationalNumber) && isObject(nationalNumber.countries)) {
          metadata = nationalNumber;
          var e164Number = countryOrCountryCallingCode;
          if (!E164_NUMBER_REGEXP.test(e164Number)) {
            throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
          }
          var _extractCountryCallin = extractCountryCallingCode(e164Number, undefined, undefined, undefined, metadata),
            _countryCallingCode = _extractCountryCallin.countryCallingCode,
            number = _extractCountryCallin.number;
          nationalNumber = number;
          countryOrCountryCallingCode = _countryCallingCode;
          if (!nationalNumber) {
            throw new Error('Invalid `number` argument passed: too short');
          }
        }
        if (!nationalNumber) {
          throw new TypeError('`nationalNumber` argument is required');
        }
        if (typeof nationalNumber !== 'string') {
          throw new TypeError('`nationalNumber` argument must be a string');
        }
        validateMetadata(metadata);
        var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata),
          country = _getCountryAndCountry.country,
          countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = '+' + this.countryCallingCode + this.nationalNumber;
        this.getMetadata = function () {
          return metadata;
        };
      }
      return _createClass$1(PhoneNumber, [{
        key: "setExt",
        value: function setExt(ext) {
          this.ext = ext;
        }
      }, {
        key: "getPossibleCountries",
        value: function getPossibleCountries() {
          if (this.country) {
            return [this.country];
          }
          return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
        }
      }, {
        key: "isPossible",
        value: function isPossible() {
          return isPossiblePhoneNumber(this, {
            v2: true
          }, this.getMetadata());
        }
      }, {
        key: "isValid",
        value: function isValid() {
          return isValidNumber(this, {
            v2: true
          }, this.getMetadata());
        }
      }, {
        key: "isNonGeographic",
        value: function isNonGeographic() {
          var metadata = new Metadata(this.getMetadata());
          return metadata.isNonGeographicCallingCode(this.countryCallingCode);
        }
      }, {
        key: "isEqual",
        value: function isEqual(phoneNumber) {
          return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
        }
      }, {
        key: "getType",
        value: function getType() {
          return getNumberType(this, {
            v2: true
          }, this.getMetadata());
        }
      }, {
        key: "format",
        value: function format(_format, options) {
          return formatNumber(this, _format, options ? _objectSpread$4(_objectSpread$4({}, options), {}, {
            v2: true
          }) : {
            v2: true
          }, this.getMetadata());
        }
      }, {
        key: "formatNational",
        value: function formatNational(options) {
          return this.format('NATIONAL', options);
        }
      }, {
        key: "formatInternational",
        value: function formatInternational(options) {
          return this.format('INTERNATIONAL', options);
        }
      }, {
        key: "getURI",
        value: function getURI(options) {
          return this.format('RFC3966', options);
        }
      }]);
    }();
    var isCountryCode = function isCountryCode(value) {
      return /^[A-Z]{2}$/.test(value);
    };
    function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
      var country;
      var countryCallingCode;
      var metadata = new Metadata(metadataJson);
      if (isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
      } else {
        countryCallingCode = countryOrCountryCallingCode;
      }
      return {
        country: country,
        countryCallingCode: countryCallingCode
      };
    }
    var E164_NUMBER_REGEXP = /^\+\d+$/;

    function _typeof$4(o) {
      "@babel/helpers - typeof";

      return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, _typeof$4(o);
    }
    function _defineProperties(e, r) {
      for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey$4(o.key), o);
      }
    }
    function _createClass(e, r, t) {
      return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }
    function _toPropertyKey$4(t) {
      var i = _toPrimitive$4(t, "string");
      return "symbol" == _typeof$4(i) ? i : i + "";
    }
    function _toPrimitive$4(t, r) {
      if ("object" != _typeof$4(t) || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof$4(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    function _classCallCheck(a, n) {
      if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _callSuper(t, o, e) {
      return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
    }
    function _possibleConstructorReturn(t, e) {
      if (e && ("object" == _typeof$4(e) || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return _assertThisInitialized(t);
    }
    function _assertThisInitialized(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function _inherits(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e && _setPrototypeOf(t, e);
    }
    function _wrapNativeSuper(t) {
      var r = "function" == typeof Map ? new Map() : void 0;
      return _wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
          if (r.has(t)) return r.get(t);
          r.set(t, Wrapper);
        }
        function Wrapper() {
          return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), _setPrototypeOf(Wrapper, t);
      }, _wrapNativeSuper(t);
    }
    function _construct(t, e, r) {
      if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
      var o = [null];
      o.push.apply(o, e);
      var p = new (t.bind.apply(t, o))();
      return r && _setPrototypeOf(p, r.prototype), p;
    }
    function _isNativeReflectConstruct() {
      try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (t) {}
      return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
      })();
    }
    function _isNativeFunction(t) {
      try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
      } catch (n) {
        return "function" == typeof t;
      }
    }
    function _setPrototypeOf(t, e) {
      return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
        return t.__proto__ = e, t;
      }, _setPrototypeOf(t, e);
    }
    function _getPrototypeOf(t) {
      return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, _getPrototypeOf(t);
    }
    var ParseError = function (_Error) {
      function ParseError(code) {
        var _this;
        _classCallCheck(this, ParseError);
        _this = _callSuper(this, ParseError, [code]);
        Object.setPrototypeOf(_this, ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
      }
      _inherits(ParseError, _Error);
      return _createClass(ParseError);
    }(_wrapNativeSuper(Error));

    var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i');
    function extractExtension(number) {
      var start = number.search(EXTN_PATTERN);
      if (start < 0) {
        return {};
      }
      var numberWithoutExtension = number.slice(0, start);
      var matches = number.match(EXTN_PATTERN);
      var i = 1;
      while (i < matches.length) {
        if (matches[i]) {
          return {
            number: numberWithoutExtension,
            ext: matches[i]
          };
        }
        i++;
      }
    }

    var DIGITS = {
      '0': '0',
      '1': '1',
      '2': '2',
      '3': '3',
      '4': '4',
      '5': '5',
      '6': '6',
      '7': '7',
      '8': '8',
      '9': '9',
      "\uFF10": '0',
      "\uFF11": '1',
      "\uFF12": '2',
      "\uFF13": '3',
      "\uFF14": '4',
      "\uFF15": '5',
      "\uFF16": '6',
      "\uFF17": '7',
      "\uFF18": '8',
      "\uFF19": '9',
      "\u0660": '0',
      "\u0661": '1',
      "\u0662": '2',
      "\u0663": '3',
      "\u0664": '4',
      "\u0665": '5',
      "\u0666": '6',
      "\u0667": '7',
      "\u0668": '8',
      "\u0669": '9',
      "\u06F0": '0',
      "\u06F1": '1',
      "\u06F2": '2',
      "\u06F3": '3',
      "\u06F4": '4',
      "\u06F5": '5',
      "\u06F6": '6',
      "\u06F7": '7',
      "\u06F8": '8',
      "\u06F9": '9'
    };
    function parseDigit(character) {
      return DIGITS[character];
    }

    function _createForOfIteratorHelperLoose(r, e) {
      var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (t) return (t = t.call(r)).next.bind(t);
      if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function () {
          return o >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[o++]
          };
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray$1(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray$1(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0;
      }
    }
    function _arrayLikeToArray$1(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function parseIncompletePhoneNumber(string) {
      var result = '';
      for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
        var character = _step.value;
        result += parsePhoneNumberCharacter(character, result) || '';
      }
      return result;
    }
    function parsePhoneNumberCharacter(character, prevParsedCharacters, eventListener) {
      if (character === '+') {
        if (prevParsedCharacters) {
          if (typeof eventListener === 'function') {
            eventListener('end');
          }
          return;
        }
        return '+';
      }
      return parseDigit(character);
    }

    var PLUS_SIGN = '+';
    var RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
    var RFC3966_PHONE_DIGIT_ = '(' + '[' + VALID_DIGITS + ']' + '|' + RFC3966_VISUAL_SEPARATOR_ + ')';
    var RFC3966_GLOBAL_NUMBER_DIGITS_ = '^' + '\\' + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + '*' + '[' + VALID_DIGITS + ']' + RFC3966_PHONE_DIGIT_ + '*' + '$';
    var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, 'g');
    var ALPHANUM_ = VALID_DIGITS;
    var RFC3966_DOMAINLABEL_ = '[' + ALPHANUM_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
    var VALID_ALPHA_ = 'a-zA-Z';
    var RFC3966_TOPLABEL_ = '[' + VALID_ALPHA_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
    var RFC3966_DOMAINNAME_ = '^(' + RFC3966_DOMAINLABEL_ + '\\.)*' + RFC3966_TOPLABEL_ + '\\.?$';
    var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, 'g');
    var RFC3966_PREFIX_ = 'tel:';
    var RFC3966_PHONE_CONTEXT_ = ';phone-context=';
    var RFC3966_ISDN_SUBADDRESS_ = ';isub=';
    function extractPhoneContext(numberToExtractFrom) {
      var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
      if (indexOfPhoneContext < 0) {
        return null;
      }
      var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
      if (phoneContextStart >= numberToExtractFrom.length) {
        return '';
      }
      var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart);
      if (phoneContextEnd >= 0) {
        return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
      } else {
        return numberToExtractFrom.substring(phoneContextStart);
      }
    }
    function isPhoneContextValid(phoneContext) {
      if (phoneContext === null) {
        return true;
      }
      if (phoneContext.length === 0) {
        return false;
      }
      return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
    }

    function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
      var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
      var phoneContext = extractPhoneContext(numberToParse);
      if (!isPhoneContextValid(phoneContext)) {
        throw new ParseError('NOT_A_NUMBER');
      }
      var phoneNumberString;
      if (phoneContext === null) {
        phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
      } else {
        phoneNumberString = '';
        if (phoneContext.charAt(0) === PLUS_SIGN) {
          phoneNumberString += phoneContext;
        }
        var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
        var indexOfNationalNumber;
        if (indexOfRfc3966Prefix >= 0) {
          indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
        } else {
          indexOfNationalNumber = 0;
        }
        var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
      }
      var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
      if (indexOfIsdn > 0) {
        phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
      }
      if (phoneNumberString !== '') {
        return phoneNumberString;
      }
    }

    var MAX_INPUT_STRING_LENGTH = 250;
    var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']');
    var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
    function parse(text, options, metadata) {
      options = options || {};
      metadata = new Metadata(metadata);
      if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) {
          throw new ParseError('INVALID_COUNTRY');
        }
        throw new Error("Unknown country: ".concat(options.defaultCountry));
      }
      var _parseInput = parseInput(text, options.v2, options.extract),
        formattedPhoneNumber = _parseInput.number,
        ext = _parseInput.ext,
        error = _parseInput.error;
      if (!formattedPhoneNumber) {
        if (options.v2) {
          if (error === 'TOO_SHORT') {
            throw new ParseError('TOO_SHORT');
          }
          throw new ParseError('NOT_A_NUMBER');
        }
        return {};
      }
      var _parsePhoneNumber = parsePhoneNumber$3(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
        country = _parsePhoneNumber.country,
        nationalNumber = _parsePhoneNumber.nationalNumber,
        countryCallingCode = _parsePhoneNumber.countryCallingCode,
        countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource,
        carrierCode = _parsePhoneNumber.carrierCode;
      if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) {
          throw new ParseError('INVALID_COUNTRY');
        }
        return {};
      }
      if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
        if (options.v2) {
          throw new ParseError('TOO_SHORT');
        }
        return {};
      }
      if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
        if (options.v2) {
          throw new ParseError('TOO_LONG');
        }
        return {};
      }
      if (options.v2) {
        var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) {
          phoneNumber.country = country;
        }
        if (carrierCode) {
          phoneNumber.carrierCode = carrierCode;
        }
        if (ext) {
          phoneNumber.ext = ext;
        }
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
      }
      var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;
      if (!options.extended) {
        return valid ? result(country, nationalNumber, ext) : {};
      }
      return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, country, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
      };
    }
    function _extractFormattedPhoneNumber(text, extract, throwOnError) {
      if (!text) {
        return;
      }
      if (text.length > MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) {
          throw new ParseError('TOO_LONG');
        }
        return;
      }
      if (extract === false) {
        return text;
      }
      var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
      if (startsAt < 0) {
        return;
      }
      return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
    }
    function parseInput(text, v2, extract) {
      var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
          return _extractFormattedPhoneNumber(text, extract, v2);
        }
      });
      if (!number) {
        return {};
      }
      if (!isViablePhoneNumber(number)) {
        if (isViablePhoneNumberStart(number)) {
          return {
            error: 'TOO_SHORT'
          };
        }
        return {};
      }
      var withExtensionStripped = extractExtension(number);
      if (withExtensionStripped.ext) {
        return withExtensionStripped;
      }
      return {
        number: number
      };
    }
    function result(country, nationalNumber, ext) {
      var result = {
        country: country,
        phone: nationalNumber
      };
      if (ext) {
        result.ext = ext;
      }
      return result;
    }
    function parsePhoneNumber$3(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
      var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), undefined, defaultCountry, defaultCallingCode, metadata.metadata),
        countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource,
        countryCallingCode = _extractCountryCallin.countryCallingCode,
        number = _extractCountryCallin.number;
      var country;
      if (countryCallingCode) {
        metadata.selectNumberingPlan(countryCallingCode);
      } else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) {
          country = defaultCountry;
        }
        countryCallingCode = defaultCallingCode || getCountryCallingCode$1(defaultCountry, metadata.metadata);
      } else return {};
      if (!number) {
        return {
          countryCallingCodeSource: countryCallingCodeSource,
          countryCallingCode: countryCallingCode
        };
      }
      var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), country, metadata),
        nationalNumber = _extractNationalNumbe.nationalNumber,
        carrierCode = _extractNationalNumbe.carrierCode;
      var exactCountry = getCountryByCallingCode(countryCallingCode, {
        nationalNumber: nationalNumber,
        metadata: metadata
      });
      if (exactCountry) {
        country = exactCountry;
        if (exactCountry === '001') ; else {
          metadata.selectNumberingPlan(country);
        }
      }
      return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
      };
    }

    function _typeof$3(o) {
      "@babel/helpers - typeof";

      return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, _typeof$3(o);
    }
    function ownKeys$3(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread$3(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) {
          _defineProperty$3(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
      }
      return e;
    }
    function _defineProperty$3(e, r, t) {
      return (r = _toPropertyKey$3(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }
    function _toPropertyKey$3(t) {
      var i = _toPrimitive$3(t, "string");
      return "symbol" == _typeof$3(i) ? i : i + "";
    }
    function _toPrimitive$3(t, r) {
      if ("object" != _typeof$3(t) || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof$3(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    function parsePhoneNumberWithError(text, options, metadata) {
      return parse(text, _objectSpread$3(_objectSpread$3({}, options), {}, {
        v2: true
      }), metadata);
    }

    function _typeof$2(o) {
      "@babel/helpers - typeof";

      return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, _typeof$2(o);
    }
    function ownKeys$2(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread$2(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) {
          _defineProperty$2(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
      }
      return e;
    }
    function _defineProperty$2(e, r, t) {
      return (r = _toPropertyKey$2(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }
    function _toPropertyKey$2(t) {
      var i = _toPrimitive$2(t, "string");
      return "symbol" == _typeof$2(i) ? i : i + "";
    }
    function _toPrimitive$2(t, r) {
      if ("object" != _typeof$2(t) || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof$2(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    function _slicedToArray(r, e) {
      return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
      }
    }
    function _arrayLikeToArray(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function _iterableToArrayLimit(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e,
          n,
          i,
          u,
          a = [],
          f = !0,
          o = !1;
        try {
          if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t) return;
            f = !1;
          } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
          o = !0, n = r;
        } finally {
          try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles(r) {
      if (Array.isArray(r)) return r;
    }
    function normalizeArguments(args) {
      var _Array$prototype$slic = Array.prototype.slice.call(args),
        _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4),
        arg_1 = _Array$prototype$slic2[0],
        arg_2 = _Array$prototype$slic2[1],
        arg_3 = _Array$prototype$slic2[2],
        arg_4 = _Array$prototype$slic2[3];
      var text;
      var options;
      var metadata;
      if (typeof arg_1 === 'string') {
        text = arg_1;
      } else throw new TypeError('A text for parsing must be a string.');
      if (!arg_2 || typeof arg_2 === 'string') {
        if (arg_4) {
          options = arg_3;
          metadata = arg_4;
        } else {
          options = undefined;
          metadata = arg_3;
        }
        if (arg_2) {
          options = _objectSpread$2({
            defaultCountry: arg_2
          }, options);
        }
      } else if (isObject(arg_2)) {
        if (arg_3) {
          options = arg_2;
          metadata = arg_3;
        } else {
          metadata = arg_2;
        }
      } else throw new Error("Invalid second argument: ".concat(arg_2));
      return {
        text: text,
        options: options,
        metadata: metadata
      };
    }

    function _typeof$1(o) {
      "@babel/helpers - typeof";

      return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, _typeof$1(o);
    }
    function ownKeys$1(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread$1(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
          _defineProperty$1(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
      }
      return e;
    }
    function _defineProperty$1(e, r, t) {
      return (r = _toPropertyKey$1(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }
    function _toPropertyKey$1(t) {
      var i = _toPrimitive$1(t, "string");
      return "symbol" == _typeof$1(i) ? i : i + "";
    }
    function _toPrimitive$1(t, r) {
      if ("object" != _typeof$1(t) || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof$1(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    function parsePhoneNumber$2(text, options, metadata) {
      if (options && options.defaultCountry && !isSupportedCountry$1(options.defaultCountry, metadata)) {
        options = _objectSpread$1(_objectSpread$1({}, options), {}, {
          defaultCountry: undefined
        });
      }
      try {
        return parsePhoneNumberWithError(text, options, metadata);
      } catch (error) {
        if (error instanceof ParseError) ; else {
          throw error;
        }
      }
    }

    function parsePhoneNumber$1() {
      var _normalizeArguments = normalizeArguments(arguments),
        text = _normalizeArguments.text,
        options = _normalizeArguments.options,
        metadata = _normalizeArguments.metadata;
      return parsePhoneNumber$2(text, options, metadata);
    }

    function _typeof(o) {
      "@babel/helpers - typeof";

      return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
        return typeof o;
      } : function (o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, _typeof(o);
    }
    function ownKeys(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function (r) {
          return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
      }
      return e;
    }
    function _defineProperty(e, r, t) {
      return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[r] = t, e;
    }
    function _toPropertyKey(t) {
      var i = _toPrimitive(t, "string");
      return "symbol" == _typeof(i) ? i : i + "";
    }
    function _toPrimitive(t, r) {
      if ("object" != _typeof(t) || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    function isValidPhoneNumber$1() {
      var _normalizeArguments = normalizeArguments(arguments),
        text = _normalizeArguments.text,
        options = _normalizeArguments.options,
        metadata = _normalizeArguments.metadata;
      options = _objectSpread(_objectSpread({}, options), {}, {
        extract: false
      });
      var phoneNumber = parsePhoneNumber$2(text, options, metadata);
      return phoneNumber && phoneNumber.isValid() || false;
    }

    function parsePhoneNumber() {
      return withMetadataArgument(parsePhoneNumber$1, arguments);
    }

    function isValidPhoneNumber() {
      return withMetadataArgument(isValidPhoneNumber$1, arguments);
    }

    function isSupportedCountry() {
      return withMetadataArgument(isSupportedCountry$1, arguments);
    }

    function getCountryCallingCode() {
      return withMetadataArgument(getCountryCallingCode$1, arguments);
    }

    var InputFields;
    (function (InputFields) {
      InputFields["FirstName"] = "firstName";
      InputFields["LastName"] = "lastName";
      InputFields["Address1"] = "address1";
      InputFields["Address2"] = "address2";
      InputFields["Zip"] = "zip";
      InputFields["City"] = "city";
      InputFields["Phone"] = "phone";
      InputFields["Birthdate"] = "birthdate";
      InputFields["email"] = "email";
      InputFields["password"] = "password";
      InputFields["confirmPassword"] = "confirmPassword";
      InputFields["civility"] = "civility";
    })(InputFields || (InputFields = {}));
    const FormSelectors = {
      Customer: {
        BIRTHDATE: 'input[name=birthdate]',
        PHONE: 'input[name="phone"]',
        PHONE_COUNTRY_SELECT: 'select[name="phone_country_select"]',
        SUBMIT_BUTTON: 'button[type="submit"]',
        FIRST_NAME: 'input[name="firstName"]',
        LAST_NAME: 'input[name="lastName"]',
        EMAIL: 'input[name="email"]',
        PASSWORD: 'input[name="password"]',
        CIVILITY: 'select[name="civility"]',
        Shopify: {
          Selectors: {
            EMAIL: 'input[name="customer[email]"]',
            PASSWORD: 'input[name="customer[password]"]',
            CONFIRM_PASSWORD: 'input[name="customer[password_confirmation]"]'
          }
        },
        RecoverPassword: {
          EMAIL: 'input[name="email"]'
        },
        Update: {
          ID: '#profile_form',
          FORM: '#update_customer_form',
          Selectors: {
            FIRST_NAME: 'input[name="firstName"]',
            LAST_NAME: 'input[name="lastName"]',
            PHONE: 'input[name="phone"]'
          },
          Fields: {
            FirstName: 'firstName',
            LastName: 'lastName',
            Phone: 'phone'
          }
        },
        Address: {
          COUNTRY_SELECT: 'select[name="address[country]"]',
          PHONE: 'input[name="address[phone]"]',
          FIRST_NAME: 'input[name="address[first_name]"]',
          LAST_NAME: 'input[name="address[last_name]"]',
          ADDRESS_1: 'input[name="address[address1]"]',
          ADDRESS_2: 'input[name="address[address2]"]',
          ZIP: 'input[name="address[zip]"]',
          CITY: 'input[name="address[city]"]'
        }
      }
    };
    const defaultNoValidationConf = {
      noSpecialChar: undefined,
      nonLatinCharacters: undefined,
      noNumber: undefined,
      maxLength: undefined,
      minLength: 0,
      required: false
    };
    const inputTextDefaultValidationConf = {
      nonLatinCharacters: true,
      noSpecialChar: true,
      noNumber: true,
      maxLength: 35,
      minLength: 0,
      required: true
    };
    const FormValidations = {
      [InputFields.FirstName]: {
        ...inputTextDefaultValidationConf,
        minLength: 2,
        maxLength: 35
      },
      [InputFields.LastName]: {
        ...inputTextDefaultValidationConf,
        minLength: 2,
        maxLength: 35
      },
      [InputFields.Address1]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        required: true
      },
      [InputFields.Address2]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        required: false
      },
      [InputFields.City]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        maxLength: undefined,
        required: true
      },
      [InputFields.Zip]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        maxLength: 10,
        required: true
      },
      [InputFields.Phone]: {
        ...defaultNoValidationConf
      },
      [InputFields.email]: {
        ...defaultNoValidationConf,
        required: true,
        email: true
      },
      [InputFields.password]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        noSpecialChar: false,
        minLength: 5
      },
      [InputFields.confirmPassword]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        noSpecialChar: false,
        minLength: 5
      },
      [InputFields.civility]: {
        ...defaultNoValidationConf,
        required: true
      },
      [InputFields.Birthdate]: {
        ...inputTextDefaultValidationConf,
        nonLatinCharacters: false,
        noSpecialChar: false,
        maxDate: Date.now(),
        required: false,
        noNumber: false
      }
    };

    var a = {
      AD: {
        name: "Andorra",
        native: "Andorra",
        phone: [376],
        continent: "EU",
        capital: "Andorra la Vella",
        currency: ["EUR"],
        languages: ["ca"]
      },
      AE: {
        name: "United Arab Emirates",
        native: "\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629",
        phone: [971],
        continent: "AS",
        capital: "Abu Dhabi",
        currency: ["AED"],
        languages: ["ar"]
      },
      AF: {
        name: "Afghanistan",
        native: "\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        phone: [93],
        continent: "AS",
        capital: "Kabul",
        currency: ["AFN"],
        languages: ["ps", "fa", "uz", "tk"]
      },
      AG: {
        name: "Antigua and Barbuda",
        native: "Antigua and Barbuda",
        phone: [1268],
        continent: "NA",
        capital: "Saint John's",
        currency: ["XCD"],
        languages: ["en"]
      },
      AI: {
        name: "Anguilla",
        native: "Anguilla",
        phone: [1264],
        continent: "NA",
        capital: "The Valley",
        currency: ["XCD"],
        languages: ["en"]
      },
      AL: {
        name: "Albania",
        native: "Shqip\xEBria",
        phone: [355],
        continent: "EU",
        capital: "Tirana",
        currency: ["ALL"],
        languages: ["sq"]
      },
      AM: {
        name: "Armenia",
        native: "\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576",
        phone: [374],
        continent: "AS",
        capital: "Yerevan",
        currency: ["AMD"],
        languages: ["hy", "ru"]
      },
      AO: {
        name: "Angola",
        native: "Angola",
        phone: [244],
        continent: "AF",
        capital: "Luanda",
        currency: ["AOA"],
        languages: ["pt"]
      },
      AQ: {
        name: "Antarctica",
        native: "Antarctica",
        phone: [672],
        continent: "AN",
        capital: "",
        currency: [],
        languages: []
      },
      AR: {
        name: "Argentina",
        native: "Argentina",
        phone: [54],
        continent: "SA",
        capital: "Buenos Aires",
        currency: ["ARS"],
        languages: ["es", "gn"]
      },
      AS: {
        name: "American Samoa",
        native: "American Samoa",
        phone: [1684],
        continent: "OC",
        capital: "Pago Pago",
        currency: ["USD"],
        languages: ["en", "sm"]
      },
      AT: {
        name: "Austria",
        native: "\xD6sterreich",
        phone: [43],
        continent: "EU",
        capital: "Vienna",
        currency: ["EUR"],
        languages: ["de"]
      },
      AU: {
        name: "Australia",
        native: "Australia",
        phone: [61],
        continent: "OC",
        capital: "Canberra",
        currency: ["AUD"],
        languages: ["en"]
      },
      AW: {
        name: "Aruba",
        native: "Aruba",
        phone: [297],
        continent: "NA",
        capital: "Oranjestad",
        currency: ["AWG"],
        languages: ["nl", "pa"]
      },
      AX: {
        name: "Aland",
        native: "\xC5land",
        phone: [358],
        continent: "EU",
        capital: "Mariehamn",
        currency: ["EUR"],
        languages: ["sv"],
        partOf: "FI"
      },
      AZ: {
        name: "Azerbaijan",
        native: "Az\u0259rbaycan",
        phone: [994],
        continent: "AS",
        continents: ["AS", "EU"],
        capital: "Baku",
        currency: ["AZN"],
        languages: ["az"]
      },
      BA: {
        name: "Bosnia and Herzegovina",
        native: "Bosna i Hercegovina",
        phone: [387],
        continent: "EU",
        capital: "Sarajevo",
        currency: ["BAM"],
        languages: ["bs", "hr", "sr"]
      },
      BB: {
        name: "Barbados",
        native: "Barbados",
        phone: [1246],
        continent: "NA",
        capital: "Bridgetown",
        currency: ["BBD"],
        languages: ["en"]
      },
      BD: {
        name: "Bangladesh",
        native: "Bangladesh",
        phone: [880],
        continent: "AS",
        capital: "Dhaka",
        currency: ["BDT"],
        languages: ["bn"]
      },
      BE: {
        name: "Belgium",
        native: "Belgi\xEB",
        phone: [32],
        continent: "EU",
        capital: "Brussels",
        currency: ["EUR"],
        languages: ["nl", "fr", "de"]
      },
      BF: {
        name: "Burkina Faso",
        native: "Burkina Faso",
        phone: [226],
        continent: "AF",
        capital: "Ouagadougou",
        currency: ["XOF"],
        languages: ["fr", "ff"]
      },
      BG: {
        name: "Bulgaria",
        native: "\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F",
        phone: [359],
        continent: "EU",
        capital: "Sofia",
        currency: ["BGN"],
        languages: ["bg"]
      },
      BH: {
        name: "Bahrain",
        native: "\u200F\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
        phone: [973],
        continent: "AS",
        capital: "Manama",
        currency: ["BHD"],
        languages: ["ar"]
      },
      BI: {
        name: "Burundi",
        native: "Burundi",
        phone: [257],
        continent: "AF",
        capital: "Gitega",
        currency: ["BIF"],
        languages: ["fr", "rn"]
      },
      BJ: {
        name: "Benin",
        native: "B\xE9nin",
        phone: [229],
        continent: "AF",
        capital: "Porto-Novo",
        currency: ["XOF"],
        languages: ["fr"]
      },
      BL: {
        name: "Saint Barthelemy",
        native: "Saint-Barth\xE9lemy",
        phone: [590],
        continent: "NA",
        capital: "Gustavia",
        currency: ["EUR"],
        languages: ["fr"]
      },
      BM: {
        name: "Bermuda",
        native: "Bermuda",
        phone: [1441],
        continent: "NA",
        capital: "Hamilton",
        currency: ["BMD"],
        languages: ["en"]
      },
      BN: {
        name: "Brunei",
        native: "Negara Brunei Darussalam",
        phone: [673],
        continent: "AS",
        capital: "Bandar Seri Begawan",
        currency: ["BND"],
        languages: ["ms"]
      },
      BO: {
        name: "Bolivia",
        native: "Bolivia",
        phone: [591],
        continent: "SA",
        capital: "Sucre",
        currency: ["BOB", "BOV"],
        languages: ["es", "ay", "qu"]
      },
      BQ: {
        name: "Bonaire",
        native: "Bonaire",
        phone: [5997],
        continent: "NA",
        capital: "Kralendijk",
        currency: ["USD"],
        languages: ["nl"]
      },
      BR: {
        name: "Brazil",
        native: "Brasil",
        phone: [55],
        continent: "SA",
        capital: "Bras\xEDlia",
        currency: ["BRL"],
        languages: ["pt"]
      },
      BS: {
        name: "Bahamas",
        native: "Bahamas",
        phone: [1242],
        continent: "NA",
        capital: "Nassau",
        currency: ["BSD"],
        languages: ["en"]
      },
      BT: {
        name: "Bhutan",
        native: "\u02BCbrug-yul",
        phone: [975],
        continent: "AS",
        capital: "Thimphu",
        currency: ["BTN", "INR"],
        languages: ["dz"]
      },
      BV: {
        name: "Bouvet Island",
        native: "Bouvet\xF8ya",
        phone: [47],
        continent: "AN",
        capital: "",
        currency: ["NOK"],
        languages: ["no", "nb", "nn"]
      },
      BW: {
        name: "Botswana",
        native: "Botswana",
        phone: [267],
        continent: "AF",
        capital: "Gaborone",
        currency: ["BWP"],
        languages: ["en", "tn"]
      },
      BY: {
        name: "Belarus",
        native: "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C",
        phone: [375],
        continent: "EU",
        capital: "Minsk",
        currency: ["BYN"],
        languages: ["be", "ru"]
      },
      BZ: {
        name: "Belize",
        native: "Belize",
        phone: [501],
        continent: "NA",
        capital: "Belmopan",
        currency: ["BZD"],
        languages: ["en", "es"]
      },
      CA: {
        name: "Canada",
        native: "Canada",
        phone: [1],
        continent: "NA",
        capital: "Ottawa",
        currency: ["CAD"],
        languages: ["en", "fr"]
      },
      CC: {
        name: "Cocos (Keeling) Islands",
        native: "Cocos (Keeling) Islands",
        phone: [61],
        continent: "AS",
        capital: "West Island",
        currency: ["AUD"],
        languages: ["en"]
      },
      CD: {
        name: "Democratic Republic of the Congo",
        native: "R\xE9publique d\xE9mocratique du Congo",
        phone: [243],
        continent: "AF",
        capital: "Kinshasa",
        currency: ["CDF"],
        languages: ["fr", "ln", "kg", "sw", "lu"]
      },
      CF: {
        name: "Central African Republic",
        native: "K\xF6d\xF6r\xF6s\xEAse t\xEE B\xEAafr\xEEka",
        phone: [236],
        continent: "AF",
        capital: "Bangui",
        currency: ["XAF"],
        languages: ["fr", "sg"]
      },
      CG: {
        name: "Republic of the Congo",
        native: "R\xE9publique du Congo",
        phone: [242],
        continent: "AF",
        capital: "Brazzaville",
        currency: ["XAF"],
        languages: ["fr", "ln"]
      },
      CH: {
        name: "Switzerland",
        native: "Schweiz",
        phone: [41],
        continent: "EU",
        capital: "Bern",
        currency: ["CHF", "CHE", "CHW"],
        languages: ["de", "fr", "it"]
      },
      CI: {
        name: "Ivory Coast",
        native: "C\xF4te d'Ivoire",
        phone: [225],
        continent: "AF",
        capital: "Yamoussoukro",
        currency: ["XOF"],
        languages: ["fr"]
      },
      CK: {
        name: "Cook Islands",
        native: "Cook Islands",
        phone: [682],
        continent: "OC",
        capital: "Avarua",
        currency: ["NZD"],
        languages: ["en"]
      },
      CL: {
        name: "Chile",
        native: "Chile",
        phone: [56],
        continent: "SA",
        capital: "Santiago",
        currency: ["CLF", "CLP"],
        languages: ["es"]
      },
      CM: {
        name: "Cameroon",
        native: "Cameroon",
        phone: [237],
        continent: "AF",
        capital: "Yaound\xE9",
        currency: ["XAF"],
        languages: ["en", "fr"]
      },
      CN: {
        name: "China",
        native: "\u4E2D\u56FD",
        phone: [86],
        continent: "AS",
        capital: "Beijing",
        currency: ["CNY"],
        languages: ["zh"]
      },
      CO: {
        name: "Colombia",
        native: "Colombia",
        phone: [57],
        continent: "SA",
        capital: "Bogot\xE1",
        currency: ["COP"],
        languages: ["es"]
      },
      CR: {
        name: "Costa Rica",
        native: "Costa Rica",
        phone: [506],
        continent: "NA",
        capital: "San Jos\xE9",
        currency: ["CRC"],
        languages: ["es"]
      },
      CU: {
        name: "Cuba",
        native: "Cuba",
        phone: [53],
        continent: "NA",
        capital: "Havana",
        currency: ["CUP"],
        languages: ["es"]
      },
      CV: {
        name: "Cape Verde",
        native: "Cabo Verde",
        phone: [238],
        continent: "AF",
        capital: "Praia",
        currency: ["CVE"],
        languages: ["pt"]
      },
      CW: {
        name: "Curacao",
        native: "Cura\xE7ao",
        phone: [5999],
        continent: "NA",
        capital: "Willemstad",
        currency: ["ANG"],
        languages: ["nl", "pa", "en"]
      },
      CX: {
        name: "Christmas Island",
        native: "Christmas Island",
        phone: [61],
        continent: "AS",
        capital: "Flying Fish Cove",
        currency: ["AUD"],
        languages: ["en"]
      },
      CY: {
        name: "Cyprus",
        native: "\u039A\u03CD\u03C0\u03C1\u03BF\u03C2",
        phone: [357],
        continent: "EU",
        capital: "Nicosia",
        currency: ["EUR"],
        languages: ["el", "tr", "hy"]
      },
      CZ: {
        name: "Czech Republic",
        native: "\u010Cesk\xE1 republika",
        phone: [420],
        continent: "EU",
        capital: "Prague",
        currency: ["CZK"],
        languages: ["cs"]
      },
      DE: {
        name: "Germany",
        native: "Deutschland",
        phone: [49],
        continent: "EU",
        capital: "Berlin",
        currency: ["EUR"],
        languages: ["de"]
      },
      DJ: {
        name: "Djibouti",
        native: "Djibouti",
        phone: [253],
        continent: "AF",
        capital: "Djibouti",
        currency: ["DJF"],
        languages: ["fr", "ar"]
      },
      DK: {
        name: "Denmark",
        native: "Danmark",
        phone: [45],
        continent: "EU",
        continents: ["EU", "NA"],
        capital: "Copenhagen",
        currency: ["DKK"],
        languages: ["da"]
      },
      DM: {
        name: "Dominica",
        native: "Dominica",
        phone: [1767],
        continent: "NA",
        capital: "Roseau",
        currency: ["XCD"],
        languages: ["en"]
      },
      DO: {
        name: "Dominican Republic",
        native: "Rep\xFAblica Dominicana",
        phone: [1809, 1829, 1849],
        continent: "NA",
        capital: "Santo Domingo",
        currency: ["DOP"],
        languages: ["es"]
      },
      DZ: {
        name: "Algeria",
        native: "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
        phone: [213],
        continent: "AF",
        capital: "Algiers",
        currency: ["DZD"],
        languages: ["ar"]
      },
      EC: {
        name: "Ecuador",
        native: "Ecuador",
        phone: [593],
        continent: "SA",
        capital: "Quito",
        currency: ["USD"],
        languages: ["es"]
      },
      EE: {
        name: "Estonia",
        native: "Eesti",
        phone: [372],
        continent: "EU",
        capital: "Tallinn",
        currency: ["EUR"],
        languages: ["et"]
      },
      EG: {
        name: "Egypt",
        native: "\u0645\u0635\u0631\u200E",
        phone: [20],
        continent: "AF",
        continents: ["AF", "AS"],
        capital: "Cairo",
        currency: ["EGP"],
        languages: ["ar"]
      },
      EH: {
        name: "Western Sahara",
        native: "\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629",
        phone: [212],
        continent: "AF",
        capital: "El Aai\xFAn",
        currency: ["MAD", "DZD", "MRU"],
        languages: ["es"]
      },
      ER: {
        name: "Eritrea",
        native: "\u12A4\u122D\u1275\u122B",
        phone: [291],
        continent: "AF",
        capital: "Asmara",
        currency: ["ERN"],
        languages: ["ti", "ar", "en"]
      },
      ES: {
        name: "Spain",
        native: "Espa\xF1a",
        phone: [34],
        continent: "EU",
        capital: "Madrid",
        currency: ["EUR"],
        languages: ["es", "eu", "ca", "gl", "oc"]
      },
      ET: {
        name: "Ethiopia",
        native: "\u12A2\u1275\u12EE\u1335\u12EB",
        phone: [251],
        continent: "AF",
        capital: "Addis Ababa",
        currency: ["ETB"],
        languages: ["am"]
      },
      FI: {
        name: "Finland",
        native: "Suomi",
        phone: [358],
        continent: "EU",
        capital: "Helsinki",
        currency: ["EUR"],
        languages: ["fi", "sv"]
      },
      FJ: {
        name: "Fiji",
        native: "Fiji",
        phone: [679],
        continent: "OC",
        capital: "Suva",
        currency: ["FJD"],
        languages: ["en", "fj", "hi", "ur"]
      },
      FK: {
        name: "Falkland Islands",
        native: "Falkland Islands",
        phone: [500],
        continent: "SA",
        capital: "Stanley",
        currency: ["FKP"],
        languages: ["en"]
      },
      FM: {
        name: "Micronesia",
        native: "Micronesia",
        phone: [691],
        continent: "OC",
        capital: "Palikir",
        currency: ["USD"],
        languages: ["en"]
      },
      FO: {
        name: "Faroe Islands",
        native: "F\xF8royar",
        phone: [298],
        continent: "EU",
        capital: "T\xF3rshavn",
        currency: ["DKK"],
        languages: ["fo"]
      },
      FR: {
        name: "France",
        native: "France",
        phone: [33],
        continent: "EU",
        capital: "Paris",
        currency: ["EUR"],
        languages: ["fr"]
      },
      GA: {
        name: "Gabon",
        native: "Gabon",
        phone: [241],
        continent: "AF",
        capital: "Libreville",
        currency: ["XAF"],
        languages: ["fr"]
      },
      GB: {
        name: "United Kingdom",
        native: "United Kingdom",
        phone: [44],
        continent: "EU",
        capital: "London",
        currency: ["GBP"],
        languages: ["en"]
      },
      GD: {
        name: "Grenada",
        native: "Grenada",
        phone: [1473],
        continent: "NA",
        capital: "St. George's",
        currency: ["XCD"],
        languages: ["en"]
      },
      GE: {
        name: "Georgia",
        native: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD",
        phone: [995],
        continent: "AS",
        continents: ["AS", "EU"],
        capital: "Tbilisi",
        currency: ["GEL"],
        languages: ["ka"]
      },
      GF: {
        name: "French Guiana",
        native: "Guyane fran\xE7aise",
        phone: [594],
        continent: "SA",
        capital: "Cayenne",
        currency: ["EUR"],
        languages: ["fr"]
      },
      GG: {
        name: "Guernsey",
        native: "Guernsey",
        phone: [44],
        continent: "EU",
        capital: "St. Peter Port",
        currency: ["GBP"],
        languages: ["en", "fr"]
      },
      GH: {
        name: "Ghana",
        native: "Ghana",
        phone: [233],
        continent: "AF",
        capital: "Accra",
        currency: ["GHS"],
        languages: ["en"]
      },
      GI: {
        name: "Gibraltar",
        native: "Gibraltar",
        phone: [350],
        continent: "EU",
        capital: "Gibraltar",
        currency: ["GIP"],
        languages: ["en"]
      },
      GL: {
        name: "Greenland",
        native: "Kalaallit Nunaat",
        phone: [299],
        continent: "NA",
        capital: "Nuuk",
        currency: ["DKK"],
        languages: ["kl"]
      },
      GM: {
        name: "Gambia",
        native: "Gambia",
        phone: [220],
        continent: "AF",
        capital: "Banjul",
        currency: ["GMD"],
        languages: ["en"]
      },
      GN: {
        name: "Guinea",
        native: "Guin\xE9e",
        phone: [224],
        continent: "AF",
        capital: "Conakry",
        currency: ["GNF"],
        languages: ["fr", "ff"]
      },
      GP: {
        name: "Guadeloupe",
        native: "Guadeloupe",
        phone: [590],
        continent: "NA",
        capital: "Basse-Terre",
        currency: ["EUR"],
        languages: ["fr"]
      },
      GQ: {
        name: "Equatorial Guinea",
        native: "Guinea Ecuatorial",
        phone: [240],
        continent: "AF",
        capital: "Malabo",
        currency: ["XAF"],
        languages: ["es", "fr"]
      },
      GR: {
        name: "Greece",
        native: "\u0395\u03BB\u03BB\u03AC\u03B4\u03B1",
        phone: [30],
        continent: "EU",
        capital: "Athens",
        currency: ["EUR"],
        languages: ["el"]
      },
      GS: {
        name: "South Georgia and the South Sandwich Islands",
        native: "South Georgia",
        phone: [500],
        continent: "AN",
        capital: "King Edward Point",
        currency: ["GBP"],
        languages: ["en"]
      },
      GT: {
        name: "Guatemala",
        native: "Guatemala",
        phone: [502],
        continent: "NA",
        capital: "Guatemala City",
        currency: ["GTQ"],
        languages: ["es"]
      },
      GU: {
        name: "Guam",
        native: "Guam",
        phone: [1671],
        continent: "OC",
        capital: "Hag\xE5t\xF1a",
        currency: ["USD"],
        languages: ["en", "ch", "es"]
      },
      GW: {
        name: "Guinea-Bissau",
        native: "Guin\xE9-Bissau",
        phone: [245],
        continent: "AF",
        capital: "Bissau",
        currency: ["XOF"],
        languages: ["pt"]
      },
      GY: {
        name: "Guyana",
        native: "Guyana",
        phone: [592],
        continent: "SA",
        capital: "Georgetown",
        currency: ["GYD"],
        languages: ["en"]
      },
      HK: {
        name: "Hong Kong",
        native: "\u9999\u6E2F",
        phone: [852],
        continent: "AS",
        capital: "City of Victoria",
        currency: ["HKD"],
        languages: ["zh", "en"]
      },
      HM: {
        name: "Heard Island and McDonald Islands",
        native: "Heard Island and McDonald Islands",
        phone: [61],
        continent: "AN",
        capital: "",
        currency: ["AUD"],
        languages: ["en"]
      },
      HN: {
        name: "Honduras",
        native: "Honduras",
        phone: [504],
        continent: "NA",
        capital: "Tegucigalpa",
        currency: ["HNL"],
        languages: ["es"]
      },
      HR: {
        name: "Croatia",
        native: "Hrvatska",
        phone: [385],
        continent: "EU",
        capital: "Zagreb",
        currency: ["EUR"],
        languages: ["hr"]
      },
      HT: {
        name: "Haiti",
        native: "Ha\xEFti",
        phone: [509],
        continent: "NA",
        capital: "Port-au-Prince",
        currency: ["HTG", "USD"],
        languages: ["fr", "ht"]
      },
      HU: {
        name: "Hungary",
        native: "Magyarorsz\xE1g",
        phone: [36],
        continent: "EU",
        capital: "Budapest",
        currency: ["HUF"],
        languages: ["hu"]
      },
      ID: {
        name: "Indonesia",
        native: "Indonesia",
        phone: [62],
        continent: "AS",
        capital: "Jakarta",
        currency: ["IDR"],
        languages: ["id"]
      },
      IE: {
        name: "Ireland",
        native: "\xC9ire",
        phone: [353],
        continent: "EU",
        capital: "Dublin",
        currency: ["EUR"],
        languages: ["ga", "en"]
      },
      IL: {
        name: "Israel",
        native: "\u05D9\u05B4\u05E9\u05B0\u05C2\u05E8\u05B8\u05D0\u05B5\u05DC",
        phone: [972],
        continent: "AS",
        capital: "Jerusalem",
        currency: ["ILS"],
        languages: ["he", "ar"]
      },
      IM: {
        name: "Isle of Man",
        native: "Isle of Man",
        phone: [44],
        continent: "EU",
        capital: "Douglas",
        currency: ["GBP"],
        languages: ["en", "gv"]
      },
      IN: {
        name: "India",
        native: "\u092D\u093E\u0930\u0924",
        phone: [91],
        continent: "AS",
        capital: "New Delhi",
        currency: ["INR"],
        languages: ["hi", "en"]
      },
      IO: {
        name: "British Indian Ocean Territory",
        native: "British Indian Ocean Territory",
        phone: [246],
        continent: "AS",
        capital: "Diego Garcia",
        currency: ["USD"],
        languages: ["en"]
      },
      IQ: {
        name: "Iraq",
        native: "\u0627\u0644\u0639\u0631\u0627\u0642",
        phone: [964],
        continent: "AS",
        capital: "Baghdad",
        currency: ["IQD"],
        languages: ["ar", "ku"]
      },
      IR: {
        name: "Iran",
        native: "\u0627\u06CC\u0631\u0627\u0646",
        phone: [98],
        continent: "AS",
        capital: "Tehran",
        currency: ["IRR"],
        languages: ["fa"]
      },
      IS: {
        name: "Iceland",
        native: "\xCDsland",
        phone: [354],
        continent: "EU",
        capital: "Reykjavik",
        currency: ["ISK"],
        languages: ["is"]
      },
      IT: {
        name: "Italy",
        native: "Italia",
        phone: [39],
        continent: "EU",
        capital: "Rome",
        currency: ["EUR"],
        languages: ["it"]
      },
      JE: {
        name: "Jersey",
        native: "Jersey",
        phone: [44],
        continent: "EU",
        capital: "Saint Helier",
        currency: ["GBP"],
        languages: ["en", "fr"]
      },
      JM: {
        name: "Jamaica",
        native: "Jamaica",
        phone: [1876],
        continent: "NA",
        capital: "Kingston",
        currency: ["JMD"],
        languages: ["en"]
      },
      JO: {
        name: "Jordan",
        native: "\u0627\u0644\u0623\u0631\u062F\u0646",
        phone: [962],
        continent: "AS",
        capital: "Amman",
        currency: ["JOD"],
        languages: ["ar"]
      },
      JP: {
        name: "Japan",
        native: "\u65E5\u672C",
        phone: [81],
        continent: "AS",
        capital: "Tokyo",
        currency: ["JPY"],
        languages: ["ja"]
      },
      KE: {
        name: "Kenya",
        native: "Kenya",
        phone: [254],
        continent: "AF",
        capital: "Nairobi",
        currency: ["KES"],
        languages: ["en", "sw"]
      },
      KG: {
        name: "Kyrgyzstan",
        native: "\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D",
        phone: [996],
        continent: "AS",
        capital: "Bishkek",
        currency: ["KGS"],
        languages: ["ky", "ru"]
      },
      KH: {
        name: "Cambodia",
        native: "\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6",
        phone: [855],
        continent: "AS",
        capital: "Phnom Penh",
        currency: ["KHR"],
        languages: ["km"]
      },
      KI: {
        name: "Kiribati",
        native: "Kiribati",
        phone: [686],
        continent: "OC",
        capital: "South Tarawa",
        currency: ["AUD"],
        languages: ["en"]
      },
      KM: {
        name: "Comoros",
        native: "Komori",
        phone: [269],
        continent: "AF",
        capital: "Moroni",
        currency: ["KMF"],
        languages: ["ar", "fr"]
      },
      KN: {
        name: "Saint Kitts and Nevis",
        native: "Saint Kitts and Nevis",
        phone: [1869],
        continent: "NA",
        capital: "Basseterre",
        currency: ["XCD"],
        languages: ["en"]
      },
      KP: {
        name: "North Korea",
        native: "\uBD81\uD55C",
        phone: [850],
        continent: "AS",
        capital: "Pyongyang",
        currency: ["KPW"],
        languages: ["ko"]
      },
      KR: {
        name: "South Korea",
        native: "\uB300\uD55C\uBBFC\uAD6D",
        phone: [82],
        continent: "AS",
        capital: "Seoul",
        currency: ["KRW"],
        languages: ["ko"]
      },
      KW: {
        name: "Kuwait",
        native: "\u0627\u0644\u0643\u0648\u064A\u062A",
        phone: [965],
        continent: "AS",
        capital: "Kuwait City",
        currency: ["KWD"],
        languages: ["ar"]
      },
      KY: {
        name: "Cayman Islands",
        native: "Cayman Islands",
        phone: [1345],
        continent: "NA",
        capital: "George Town",
        currency: ["KYD"],
        languages: ["en"]
      },
      KZ: {
        name: "Kazakhstan",
        native: "\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D",
        phone: [7],
        continent: "AS",
        continents: ["AS", "EU"],
        capital: "Astana",
        currency: ["KZT"],
        languages: ["kk", "ru"]
      },
      LA: {
        name: "Laos",
        native: "\u0EAA\u0E9B\u0E9B\u0EA5\u0EB2\u0EA7",
        phone: [856],
        continent: "AS",
        capital: "Vientiane",
        currency: ["LAK"],
        languages: ["lo"]
      },
      LB: {
        name: "Lebanon",
        native: "\u0644\u0628\u0646\u0627\u0646",
        phone: [961],
        continent: "AS",
        capital: "Beirut",
        currency: ["LBP"],
        languages: ["ar", "fr"]
      },
      LC: {
        name: "Saint Lucia",
        native: "Saint Lucia",
        phone: [1758],
        continent: "NA",
        capital: "Castries",
        currency: ["XCD"],
        languages: ["en"]
      },
      LI: {
        name: "Liechtenstein",
        native: "Liechtenstein",
        phone: [423],
        continent: "EU",
        capital: "Vaduz",
        currency: ["CHF"],
        languages: ["de"]
      },
      LK: {
        name: "Sri Lanka",
        native: "\u015Br\u012B la\u1E43k\u0101va",
        phone: [94],
        continent: "AS",
        capital: "Colombo",
        currency: ["LKR"],
        languages: ["si", "ta"]
      },
      LR: {
        name: "Liberia",
        native: "Liberia",
        phone: [231],
        continent: "AF",
        capital: "Monrovia",
        currency: ["LRD"],
        languages: ["en"]
      },
      LS: {
        name: "Lesotho",
        native: "Lesotho",
        phone: [266],
        continent: "AF",
        capital: "Maseru",
        currency: ["LSL", "ZAR"],
        languages: ["en", "st"]
      },
      LT: {
        name: "Lithuania",
        native: "Lietuva",
        phone: [370],
        continent: "EU",
        capital: "Vilnius",
        currency: ["EUR"],
        languages: ["lt"]
      },
      LU: {
        name: "Luxembourg",
        native: "Luxembourg",
        phone: [352],
        continent: "EU",
        capital: "Luxembourg",
        currency: ["EUR"],
        languages: ["fr", "de", "lb"]
      },
      LV: {
        name: "Latvia",
        native: "Latvija",
        phone: [371],
        continent: "EU",
        capital: "Riga",
        currency: ["EUR"],
        languages: ["lv"]
      },
      LY: {
        name: "Libya",
        native: "\u200F\u0644\u064A\u0628\u064A\u0627",
        phone: [218],
        continent: "AF",
        capital: "Tripoli",
        currency: ["LYD"],
        languages: ["ar"]
      },
      MA: {
        name: "Morocco",
        native: "\u0627\u0644\u0645\u063A\u0631\u0628",
        phone: [212],
        continent: "AF",
        capital: "Rabat",
        currency: ["MAD"],
        languages: ["ar"]
      },
      MC: {
        name: "Monaco",
        native: "Monaco",
        phone: [377],
        continent: "EU",
        capital: "Monaco",
        currency: ["EUR"],
        languages: ["fr"]
      },
      MD: {
        name: "Moldova",
        native: "Moldova",
        phone: [373],
        continent: "EU",
        capital: "Chi\u0219in\u0103u",
        currency: ["MDL"],
        languages: ["ro"]
      },
      ME: {
        name: "Montenegro",
        native: "\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430",
        phone: [382],
        continent: "EU",
        capital: "Podgorica",
        currency: ["EUR"],
        languages: ["sr", "bs", "sq", "hr"]
      },
      MF: {
        name: "Saint Martin",
        native: "Saint-Martin",
        phone: [590],
        continent: "NA",
        capital: "Marigot",
        currency: ["EUR"],
        languages: ["en", "fr", "nl"]
      },
      MG: {
        name: "Madagascar",
        native: "Madagasikara",
        phone: [261],
        continent: "AF",
        capital: "Antananarivo",
        currency: ["MGA"],
        languages: ["fr", "mg"]
      },
      MH: {
        name: "Marshall Islands",
        native: "M\u0327aje\u013C",
        phone: [692],
        continent: "OC",
        capital: "Majuro",
        currency: ["USD"],
        languages: ["en", "mh"]
      },
      MK: {
        name: "North Macedonia",
        native: "\u0421\u0435\u0432\u0435\u0440\u043D\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430",
        phone: [389],
        continent: "EU",
        capital: "Skopje",
        currency: ["MKD"],
        languages: ["mk"]
      },
      ML: {
        name: "Mali",
        native: "Mali",
        phone: [223],
        continent: "AF",
        capital: "Bamako",
        currency: ["XOF"],
        languages: ["fr"]
      },
      MM: {
        name: "Myanmar (Burma)",
        native: "\u1019\u103C\u1014\u103A\u1019\u102C",
        phone: [95],
        continent: "AS",
        capital: "Naypyidaw",
        currency: ["MMK"],
        languages: ["my"]
      },
      MN: {
        name: "Mongolia",
        native: "\u041C\u043E\u043D\u0433\u043E\u043B \u0443\u043B\u0441",
        phone: [976],
        continent: "AS",
        capital: "Ulan Bator",
        currency: ["MNT"],
        languages: ["mn"]
      },
      MO: {
        name: "Macao",
        native: "\u6FB3\u9580",
        phone: [853],
        continent: "AS",
        capital: "",
        currency: ["MOP"],
        languages: ["zh", "pt"]
      },
      MP: {
        name: "Northern Mariana Islands",
        native: "Northern Mariana Islands",
        phone: [1670],
        continent: "OC",
        capital: "Saipan",
        currency: ["USD"],
        languages: ["en", "ch"]
      },
      MQ: {
        name: "Martinique",
        native: "Martinique",
        phone: [596],
        continent: "NA",
        capital: "Fort-de-France",
        currency: ["EUR"],
        languages: ["fr"]
      },
      MR: {
        name: "Mauritania",
        native: "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627",
        phone: [222],
        continent: "AF",
        capital: "Nouakchott",
        currency: ["MRU"],
        languages: ["ar"]
      },
      MS: {
        name: "Montserrat",
        native: "Montserrat",
        phone: [1664],
        continent: "NA",
        capital: "Plymouth",
        currency: ["XCD"],
        languages: ["en"]
      },
      MT: {
        name: "Malta",
        native: "Malta",
        phone: [356],
        continent: "EU",
        capital: "Valletta",
        currency: ["EUR"],
        languages: ["mt", "en"]
      },
      MU: {
        name: "Mauritius",
        native: "Maurice",
        phone: [230],
        continent: "AF",
        capital: "Port Louis",
        currency: ["MUR"],
        languages: ["en"]
      },
      MV: {
        name: "Maldives",
        native: "Maldives",
        phone: [960],
        continent: "AS",
        capital: "Mal\xE9",
        currency: ["MVR"],
        languages: ["dv"]
      },
      MW: {
        name: "Malawi",
        native: "Malawi",
        phone: [265],
        continent: "AF",
        capital: "Lilongwe",
        currency: ["MWK"],
        languages: ["en", "ny"]
      },
      MX: {
        name: "Mexico",
        native: "M\xE9xico",
        phone: [52],
        continent: "NA",
        capital: "Mexico City",
        currency: ["MXN"],
        languages: ["es"]
      },
      MY: {
        name: "Malaysia",
        native: "Malaysia",
        phone: [60],
        continent: "AS",
        capital: "Kuala Lumpur",
        currency: ["MYR"],
        languages: ["ms"]
      },
      MZ: {
        name: "Mozambique",
        native: "Mo\xE7ambique",
        phone: [258],
        continent: "AF",
        capital: "Maputo",
        currency: ["MZN"],
        languages: ["pt"]
      },
      NA: {
        name: "Namibia",
        native: "Namibia",
        phone: [264],
        continent: "AF",
        capital: "Windhoek",
        currency: ["NAD", "ZAR"],
        languages: ["en", "af"]
      },
      NC: {
        name: "New Caledonia",
        native: "Nouvelle-Cal\xE9donie",
        phone: [687],
        continent: "OC",
        capital: "Noum\xE9a",
        currency: ["XPF"],
        languages: ["fr"]
      },
      NE: {
        name: "Niger",
        native: "Niger",
        phone: [227],
        continent: "AF",
        capital: "Niamey",
        currency: ["XOF"],
        languages: ["fr"]
      },
      NF: {
        name: "Norfolk Island",
        native: "Norfolk Island",
        phone: [672],
        continent: "OC",
        capital: "Kingston",
        currency: ["AUD"],
        languages: ["en"]
      },
      NG: {
        name: "Nigeria",
        native: "Nigeria",
        phone: [234],
        continent: "AF",
        capital: "Abuja",
        currency: ["NGN"],
        languages: ["en"]
      },
      NI: {
        name: "Nicaragua",
        native: "Nicaragua",
        phone: [505],
        continent: "NA",
        capital: "Managua",
        currency: ["NIO"],
        languages: ["es"]
      },
      NL: {
        name: "Netherlands",
        native: "Nederland",
        phone: [31],
        continent: "EU",
        capital: "Amsterdam",
        currency: ["EUR"],
        languages: ["nl"]
      },
      NO: {
        name: "Norway",
        native: "Norge",
        phone: [47],
        continent: "EU",
        capital: "Oslo",
        currency: ["NOK"],
        languages: ["no", "nb", "nn"]
      },
      NP: {
        name: "Nepal",
        native: "\u0928\u0947\u092A\u093E\u0932",
        phone: [977],
        continent: "AS",
        capital: "Kathmandu",
        currency: ["NPR"],
        languages: ["ne"]
      },
      NR: {
        name: "Nauru",
        native: "Nauru",
        phone: [674],
        continent: "OC",
        capital: "Yaren",
        currency: ["AUD"],
        languages: ["en", "na"]
      },
      NU: {
        name: "Niue",
        native: "Niu\u0113",
        phone: [683],
        continent: "OC",
        capital: "Alofi",
        currency: ["NZD"],
        languages: ["en"]
      },
      NZ: {
        name: "New Zealand",
        native: "New Zealand",
        phone: [64],
        continent: "OC",
        capital: "Wellington",
        currency: ["NZD"],
        languages: ["en", "mi"]
      },
      OM: {
        name: "Oman",
        native: "\u0639\u0645\u0627\u0646",
        phone: [968],
        continent: "AS",
        capital: "Muscat",
        currency: ["OMR"],
        languages: ["ar"]
      },
      PA: {
        name: "Panama",
        native: "Panam\xE1",
        phone: [507],
        continent: "NA",
        capital: "Panama City",
        currency: ["PAB", "USD"],
        languages: ["es"]
      },
      PE: {
        name: "Peru",
        native: "Per\xFA",
        phone: [51],
        continent: "SA",
        capital: "Lima",
        currency: ["PEN"],
        languages: ["es"]
      },
      PF: {
        name: "French Polynesia",
        native: "Polyn\xE9sie fran\xE7aise",
        phone: [689],
        continent: "OC",
        capital: "Papeet\u0113",
        currency: ["XPF"],
        languages: ["fr"]
      },
      PG: {
        name: "Papua New Guinea",
        native: "Papua Niugini",
        phone: [675],
        continent: "OC",
        capital: "Port Moresby",
        currency: ["PGK"],
        languages: ["en"]
      },
      PH: {
        name: "Philippines",
        native: "Pilipinas",
        phone: [63],
        continent: "AS",
        capital: "Manila",
        currency: ["PHP"],
        languages: ["en", "tl"]
      },
      PK: {
        name: "Pakistan",
        native: "Pakistan",
        phone: [92],
        continent: "AS",
        capital: "Islamabad",
        currency: ["PKR"],
        languages: ["en", "ur"]
      },
      PL: {
        name: "Poland",
        native: "Polska",
        phone: [48],
        continent: "EU",
        capital: "Warsaw",
        currency: ["PLN"],
        languages: ["pl"]
      },
      PM: {
        name: "Saint Pierre and Miquelon",
        native: "Saint-Pierre-et-Miquelon",
        phone: [508],
        continent: "NA",
        capital: "Saint-Pierre",
        currency: ["EUR"],
        languages: ["fr"]
      },
      PN: {
        name: "Pitcairn Islands",
        native: "Pitcairn Islands",
        phone: [64],
        continent: "OC",
        capital: "Adamstown",
        currency: ["NZD"],
        languages: ["en"]
      },
      PR: {
        name: "Puerto Rico",
        native: "Puerto Rico",
        phone: [1787, 1939],
        continent: "NA",
        capital: "San Juan",
        currency: ["USD"],
        languages: ["es", "en"]
      },
      PS: {
        name: "Palestine",
        native: "\u0641\u0644\u0633\u0637\u064A\u0646",
        phone: [970],
        continent: "AS",
        capital: "Ramallah",
        currency: ["ILS"],
        languages: ["ar"]
      },
      PT: {
        name: "Portugal",
        native: "Portugal",
        phone: [351],
        continent: "EU",
        capital: "Lisbon",
        currency: ["EUR"],
        languages: ["pt"]
      },
      PW: {
        name: "Palau",
        native: "Palau",
        phone: [680],
        continent: "OC",
        capital: "Ngerulmud",
        currency: ["USD"],
        languages: ["en"]
      },
      PY: {
        name: "Paraguay",
        native: "Paraguay",
        phone: [595],
        continent: "SA",
        capital: "Asunci\xF3n",
        currency: ["PYG"],
        languages: ["es", "gn"]
      },
      QA: {
        name: "Qatar",
        native: "\u0642\u0637\u0631",
        phone: [974],
        continent: "AS",
        capital: "Doha",
        currency: ["QAR"],
        languages: ["ar"]
      },
      RE: {
        name: "Reunion",
        native: "La R\xE9union",
        phone: [262],
        continent: "AF",
        capital: "Saint-Denis",
        currency: ["EUR"],
        languages: ["fr"]
      },
      RO: {
        name: "Romania",
        native: "Rom\xE2nia",
        phone: [40],
        continent: "EU",
        capital: "Bucharest",
        currency: ["RON"],
        languages: ["ro"]
      },
      RS: {
        name: "Serbia",
        native: "\u0421\u0440\u0431\u0438\u0458\u0430",
        phone: [381],
        continent: "EU",
        capital: "Belgrade",
        currency: ["RSD"],
        languages: ["sr"]
      },
      RU: {
        name: "Russia",
        native: "\u0420\u043E\u0441\u0441\u0438\u044F",
        phone: [7],
        continent: "AS",
        continents: ["AS", "EU"],
        capital: "Moscow",
        currency: ["RUB"],
        languages: ["ru"]
      },
      RW: {
        name: "Rwanda",
        native: "Rwanda",
        phone: [250],
        continent: "AF",
        capital: "Kigali",
        currency: ["RWF"],
        languages: ["rw", "en", "fr"]
      },
      SA: {
        name: "Saudi Arabia",
        native: "\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
        phone: [966],
        continent: "AS",
        capital: "Riyadh",
        currency: ["SAR"],
        languages: ["ar"]
      },
      SB: {
        name: "Solomon Islands",
        native: "Solomon Islands",
        phone: [677],
        continent: "OC",
        capital: "Honiara",
        currency: ["SBD"],
        languages: ["en"]
      },
      SC: {
        name: "Seychelles",
        native: "Seychelles",
        phone: [248],
        continent: "AF",
        capital: "Victoria",
        currency: ["SCR"],
        languages: ["fr", "en"]
      },
      SD: {
        name: "Sudan",
        native: "\u0627\u0644\u0633\u0648\u062F\u0627\u0646",
        phone: [249],
        continent: "AF",
        capital: "Khartoum",
        currency: ["SDG"],
        languages: ["ar", "en"]
      },
      SE: {
        name: "Sweden",
        native: "Sverige",
        phone: [46],
        continent: "EU",
        capital: "Stockholm",
        currency: ["SEK"],
        languages: ["sv"]
      },
      SG: {
        name: "Singapore",
        native: "Singapore",
        phone: [65],
        continent: "AS",
        capital: "Singapore",
        currency: ["SGD"],
        languages: ["en", "ms", "ta", "zh"]
      },
      SH: {
        name: "Saint Helena",
        native: "Saint Helena",
        phone: [290],
        continent: "AF",
        capital: "Jamestown",
        currency: ["SHP"],
        languages: ["en"]
      },
      SI: {
        name: "Slovenia",
        native: "Slovenija",
        phone: [386],
        continent: "EU",
        capital: "Ljubljana",
        currency: ["EUR"],
        languages: ["sl"]
      },
      SJ: {
        name: "Svalbard and Jan Mayen",
        native: "Svalbard og Jan Mayen",
        phone: [4779],
        continent: "EU",
        capital: "Longyearbyen",
        currency: ["NOK"],
        languages: ["no"]
      },
      SK: {
        name: "Slovakia",
        native: "Slovensko",
        phone: [421],
        continent: "EU",
        capital: "Bratislava",
        currency: ["EUR"],
        languages: ["sk"]
      },
      SL: {
        name: "Sierra Leone",
        native: "Sierra Leone",
        phone: [232],
        continent: "AF",
        capital: "Freetown",
        currency: ["SLL"],
        languages: ["en"]
      },
      SM: {
        name: "San Marino",
        native: "San Marino",
        phone: [378],
        continent: "EU",
        capital: "City of San Marino",
        currency: ["EUR"],
        languages: ["it"]
      },
      SN: {
        name: "Senegal",
        native: "S\xE9n\xE9gal",
        phone: [221],
        continent: "AF",
        capital: "Dakar",
        currency: ["XOF"],
        languages: ["fr"]
      },
      SO: {
        name: "Somalia",
        native: "Soomaaliya",
        phone: [252],
        continent: "AF",
        capital: "Mogadishu",
        currency: ["SOS"],
        languages: ["so", "ar"]
      },
      SR: {
        name: "Suriname",
        native: "Suriname",
        phone: [597],
        continent: "SA",
        capital: "Paramaribo",
        currency: ["SRD"],
        languages: ["nl"]
      },
      SS: {
        name: "South Sudan",
        native: "South Sudan",
        phone: [211],
        continent: "AF",
        capital: "Juba",
        currency: ["SSP"],
        languages: ["en"]
      },
      ST: {
        name: "Sao Tome and Principe",
        native: "S\xE3o Tom\xE9 e Pr\xEDncipe",
        phone: [239],
        continent: "AF",
        capital: "S\xE3o Tom\xE9",
        currency: ["STN"],
        languages: ["pt"]
      },
      SV: {
        name: "El Salvador",
        native: "El Salvador",
        phone: [503],
        continent: "NA",
        capital: "San Salvador",
        currency: ["SVC", "USD"],
        languages: ["es"]
      },
      SX: {
        name: "Sint Maarten",
        native: "Sint Maarten",
        phone: [1721],
        continent: "NA",
        capital: "Philipsburg",
        currency: ["ANG"],
        languages: ["nl", "en"]
      },
      SY: {
        name: "Syria",
        native: "\u0633\u0648\u0631\u064A\u0627",
        phone: [963],
        continent: "AS",
        capital: "Damascus",
        currency: ["SYP"],
        languages: ["ar"]
      },
      SZ: {
        name: "Eswatini",
        native: "Eswatini",
        phone: [268],
        continent: "AF",
        capital: "Lobamba",
        currency: ["SZL"],
        languages: ["en", "ss"]
      },
      TC: {
        name: "Turks and Caicos Islands",
        native: "Turks and Caicos Islands",
        phone: [1649],
        continent: "NA",
        capital: "Cockburn Town",
        currency: ["USD"],
        languages: ["en"]
      },
      TD: {
        name: "Chad",
        native: "Tchad",
        phone: [235],
        continent: "AF",
        capital: "N'Djamena",
        currency: ["XAF"],
        languages: ["fr", "ar"]
      },
      TF: {
        name: "French Southern Territories",
        native: "Territoire des Terres australes et antarctiques fr",
        phone: [262],
        continent: "AN",
        capital: "Port-aux-Fran\xE7ais",
        currency: ["EUR"],
        languages: ["fr"]
      },
      TG: {
        name: "Togo",
        native: "Togo",
        phone: [228],
        continent: "AF",
        capital: "Lom\xE9",
        currency: ["XOF"],
        languages: ["fr"]
      },
      TH: {
        name: "Thailand",
        native: "\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22",
        phone: [66],
        continent: "AS",
        capital: "Bangkok",
        currency: ["THB"],
        languages: ["th"]
      },
      TJ: {
        name: "Tajikistan",
        native: "\u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D",
        phone: [992],
        continent: "AS",
        capital: "Dushanbe",
        currency: ["TJS"],
        languages: ["tg", "ru"]
      },
      TK: {
        name: "Tokelau",
        native: "Tokelau",
        phone: [690],
        continent: "OC",
        capital: "Fakaofo",
        currency: ["NZD"],
        languages: ["en"]
      },
      TL: {
        name: "East Timor",
        native: "Timor-Leste",
        phone: [670],
        continent: "OC",
        capital: "Dili",
        currency: ["USD"],
        languages: ["pt"]
      },
      TM: {
        name: "Turkmenistan",
        native: "T\xFCrkmenistan",
        phone: [993],
        continent: "AS",
        capital: "Ashgabat",
        currency: ["TMT"],
        languages: ["tk", "ru"]
      },
      TN: {
        name: "Tunisia",
        native: "\u062A\u0648\u0646\u0633",
        phone: [216],
        continent: "AF",
        capital: "Tunis",
        currency: ["TND"],
        languages: ["ar"]
      },
      TO: {
        name: "Tonga",
        native: "Tonga",
        phone: [676],
        continent: "OC",
        capital: "Nuku'alofa",
        currency: ["TOP"],
        languages: ["en", "to"]
      },
      TR: {
        name: "Turkey",
        native: "T\xFCrkiye",
        phone: [90],
        continent: "AS",
        continents: ["AS", "EU"],
        capital: "Ankara",
        currency: ["TRY"],
        languages: ["tr"]
      },
      TT: {
        name: "Trinidad and Tobago",
        native: "Trinidad and Tobago",
        phone: [1868],
        continent: "NA",
        capital: "Port of Spain",
        currency: ["TTD"],
        languages: ["en"]
      },
      TV: {
        name: "Tuvalu",
        native: "Tuvalu",
        phone: [688],
        continent: "OC",
        capital: "Funafuti",
        currency: ["AUD"],
        languages: ["en"]
      },
      TW: {
        name: "Taiwan",
        native: "\u81FA\u7063",
        phone: [886],
        continent: "AS",
        capital: "Taipei",
        currency: ["TWD"],
        languages: ["zh"]
      },
      TZ: {
        name: "Tanzania",
        native: "Tanzania",
        phone: [255],
        continent: "AF",
        capital: "Dodoma",
        currency: ["TZS"],
        languages: ["sw", "en"]
      },
      UA: {
        name: "Ukraine",
        native: "\u0423\u043A\u0440\u0430\u0457\u043D\u0430",
        phone: [380],
        continent: "EU",
        capital: "Kyiv",
        currency: ["UAH"],
        languages: ["uk"]
      },
      UG: {
        name: "Uganda",
        native: "Uganda",
        phone: [256],
        continent: "AF",
        capital: "Kampala",
        currency: ["UGX"],
        languages: ["en", "sw"]
      },
      UM: {
        name: "U.S. Minor Outlying Islands",
        native: "United States Minor Outlying Islands",
        phone: [1],
        continent: "OC",
        capital: "",
        currency: ["USD"],
        languages: ["en"]
      },
      US: {
        name: "United States",
        native: "United States",
        phone: [1],
        continent: "NA",
        capital: "Washington D.C.",
        currency: ["USD", "USN", "USS"],
        languages: ["en"]
      },
      UY: {
        name: "Uruguay",
        native: "Uruguay",
        phone: [598],
        continent: "SA",
        capital: "Montevideo",
        currency: ["UYI", "UYU"],
        languages: ["es"]
      },
      UZ: {
        name: "Uzbekistan",
        native: "O'zbekiston",
        phone: [998],
        continent: "AS",
        capital: "Tashkent",
        currency: ["UZS"],
        languages: ["uz", "ru"]
      },
      VA: {
        name: "Vatican City",
        native: "Vaticano",
        phone: [379],
        continent: "EU",
        capital: "Vatican City",
        currency: ["EUR"],
        languages: ["it", "la"]
      },
      VC: {
        name: "Saint Vincent and the Grenadines",
        native: "Saint Vincent and the Grenadines",
        phone: [1784],
        continent: "NA",
        capital: "Kingstown",
        currency: ["XCD"],
        languages: ["en"]
      },
      VE: {
        name: "Venezuela",
        native: "Venezuela",
        phone: [58],
        continent: "SA",
        capital: "Caracas",
        currency: ["VES"],
        languages: ["es"]
      },
      VG: {
        name: "British Virgin Islands",
        native: "British Virgin Islands",
        phone: [1284],
        continent: "NA",
        capital: "Road Town",
        currency: ["USD"],
        languages: ["en"]
      },
      VI: {
        name: "U.S. Virgin Islands",
        native: "United States Virgin Islands",
        phone: [1340],
        continent: "NA",
        capital: "Charlotte Amalie",
        currency: ["USD"],
        languages: ["en"]
      },
      VN: {
        name: "Vietnam",
        native: "Vi\u1EC7t Nam",
        phone: [84],
        continent: "AS",
        capital: "Hanoi",
        currency: ["VND"],
        languages: ["vi"]
      },
      VU: {
        name: "Vanuatu",
        native: "Vanuatu",
        phone: [678],
        continent: "OC",
        capital: "Port Vila",
        currency: ["VUV"],
        languages: ["bi", "en", "fr"]
      },
      WF: {
        name: "Wallis and Futuna",
        native: "Wallis et Futuna",
        phone: [681],
        continent: "OC",
        capital: "Mata-Utu",
        currency: ["XPF"],
        languages: ["fr"]
      },
      WS: {
        name: "Samoa",
        native: "Samoa",
        phone: [685],
        continent: "OC",
        capital: "Apia",
        currency: ["WST"],
        languages: ["sm", "en"]
      },
      XK: {
        name: "Kosovo",
        native: "Republika e Kosov\xEBs",
        phone: [377, 381, 383, 386],
        continent: "EU",
        capital: "Pristina",
        currency: ["EUR"],
        languages: ["sq", "sr"],
        userAssigned: !0
      },
      YE: {
        name: "Yemen",
        native: "\u0627\u0644\u064A\u064E\u0645\u064E\u0646",
        phone: [967],
        continent: "AS",
        capital: "Sana'a",
        currency: ["YER"],
        languages: ["ar"]
      },
      YT: {
        name: "Mayotte",
        native: "Mayotte",
        phone: [262],
        continent: "AF",
        capital: "Mamoudzou",
        currency: ["EUR"],
        languages: ["fr"]
      },
      ZA: {
        name: "South Africa",
        native: "South Africa",
        phone: [27],
        continent: "AF",
        capital: "Pretoria",
        currency: ["ZAR"],
        languages: ["af", "en", "nr", "st", "ss", "tn", "ts", "ve", "xh", "zu"]
      },
      ZM: {
        name: "Zambia",
        native: "Zambia",
        phone: [260],
        continent: "AF",
        capital: "Lusaka",
        currency: ["ZMW"],
        languages: ["en"]
      },
      ZW: {
        name: "Zimbabwe",
        native: "Zimbabwe",
        phone: [263],
        continent: "AF",
        capital: "Harare",
        currency: ["USD", "ZAR", "BWP", "GBP", "AUD", "CNY", "INR", "JPY"],
        languages: ["en", "sn", "nd"]
      }
    };
    var r = {
      AD: "AND",
      AE: "ARE",
      AF: "AFG",
      AG: "ATG",
      AI: "AIA",
      AL: "ALB",
      AM: "ARM",
      AO: "AGO",
      AQ: "ATA",
      AR: "ARG",
      AS: "ASM",
      AT: "AUT",
      AU: "AUS",
      AW: "ABW",
      AX: "ALA",
      AZ: "AZE",
      BA: "BIH",
      BB: "BRB",
      BD: "BGD",
      BE: "BEL",
      BF: "BFA",
      BG: "BGR",
      BH: "BHR",
      BI: "BDI",
      BJ: "BEN",
      BL: "BLM",
      BM: "BMU",
      BN: "BRN",
      BO: "BOL",
      BQ: "BES",
      BR: "BRA",
      BS: "BHS",
      BT: "BTN",
      BV: "BVT",
      BW: "BWA",
      BY: "BLR",
      BZ: "BLZ",
      CA: "CAN",
      CC: "CCK",
      CD: "COD",
      CF: "CAF",
      CG: "COG",
      CH: "CHE",
      CI: "CIV",
      CK: "COK",
      CL: "CHL",
      CM: "CMR",
      CN: "CHN",
      CO: "COL",
      CR: "CRI",
      CU: "CUB",
      CV: "CPV",
      CW: "CUW",
      CX: "CXR",
      CY: "CYP",
      CZ: "CZE",
      DE: "DEU",
      DJ: "DJI",
      DK: "DNK",
      DM: "DMA",
      DO: "DOM",
      DZ: "DZA",
      EC: "ECU",
      EE: "EST",
      EG: "EGY",
      EH: "ESH",
      ER: "ERI",
      ES: "ESP",
      ET: "ETH",
      FI: "FIN",
      FJ: "FJI",
      FK: "FLK",
      FM: "FSM",
      FO: "FRO",
      FR: "FRA",
      GA: "GAB",
      GB: "GBR",
      GD: "GRD",
      GE: "GEO",
      GF: "GUF",
      GG: "GGY",
      GH: "GHA",
      GI: "GIB",
      GL: "GRL",
      GM: "GMB",
      GN: "GIN",
      GP: "GLP",
      GQ: "GNQ",
      GR: "GRC",
      GS: "SGS",
      GT: "GTM",
      GU: "GUM",
      GW: "GNB",
      GY: "GUY",
      HK: "HKG",
      HM: "HMD",
      HN: "HND",
      HR: "HRV",
      HT: "HTI",
      HU: "HUN",
      ID: "IDN",
      IE: "IRL",
      IL: "ISR",
      IM: "IMN",
      IN: "IND",
      IO: "IOT",
      IQ: "IRQ",
      IR: "IRN",
      IS: "ISL",
      IT: "ITA",
      JE: "JEY",
      JM: "JAM",
      JO: "JOR",
      JP: "JPN",
      KE: "KEN",
      KG: "KGZ",
      KH: "KHM",
      KI: "KIR",
      KM: "COM",
      KN: "KNA",
      KP: "PRK",
      KR: "KOR",
      KW: "KWT",
      KY: "CYM",
      KZ: "KAZ",
      LA: "LAO",
      LB: "LBN",
      LC: "LCA",
      LI: "LIE",
      LK: "LKA",
      LR: "LBR",
      LS: "LSO",
      LT: "LTU",
      LU: "LUX",
      LV: "LVA",
      LY: "LBY",
      MA: "MAR",
      MC: "MCO",
      MD: "MDA",
      ME: "MNE",
      MF: "MAF",
      MG: "MDG",
      MH: "MHL",
      MK: "MKD",
      ML: "MLI",
      MM: "MMR",
      MN: "MNG",
      MO: "MAC",
      MP: "MNP",
      MQ: "MTQ",
      MR: "MRT",
      MS: "MSR",
      MT: "MLT",
      MU: "MUS",
      MV: "MDV",
      MW: "MWI",
      MX: "MEX",
      MY: "MYS",
      MZ: "MOZ",
      NA: "NAM",
      NC: "NCL",
      NE: "NER",
      NF: "NFK",
      NG: "NGA",
      NI: "NIC",
      NL: "NLD",
      NO: "NOR",
      NP: "NPL",
      NR: "NRU",
      NU: "NIU",
      NZ: "NZL",
      OM: "OMN",
      PA: "PAN",
      PE: "PER",
      PF: "PYF",
      PG: "PNG",
      PH: "PHL",
      PK: "PAK",
      PL: "POL",
      PM: "SPM",
      PN: "PCN",
      PR: "PRI",
      PS: "PSE",
      PT: "PRT",
      PW: "PLW",
      PY: "PRY",
      QA: "QAT",
      RE: "REU",
      RO: "ROU",
      RS: "SRB",
      RU: "RUS",
      RW: "RWA",
      SA: "SAU",
      SB: "SLB",
      SC: "SYC",
      SD: "SDN",
      SE: "SWE",
      SG: "SGP",
      SH: "SHN",
      SI: "SVN",
      SJ: "SJM",
      SK: "SVK",
      SL: "SLE",
      SM: "SMR",
      SN: "SEN",
      SO: "SOM",
      SR: "SUR",
      SS: "SSD",
      ST: "STP",
      SV: "SLV",
      SX: "SXM",
      SY: "SYR",
      SZ: "SWZ",
      TC: "TCA",
      TD: "TCD",
      TF: "ATF",
      TG: "TGO",
      TH: "THA",
      TJ: "TJK",
      TK: "TKL",
      TL: "TLS",
      TM: "TKM",
      TN: "TUN",
      TO: "TON",
      TR: "TUR",
      TT: "TTO",
      TV: "TUV",
      TW: "TWN",
      TZ: "TZA",
      UA: "UKR",
      UG: "UGA",
      UM: "UMI",
      US: "USA",
      UY: "URY",
      UZ: "UZB",
      VA: "VAT",
      VC: "VCT",
      VE: "VEN",
      VG: "VGB",
      VI: "VIR",
      VN: "VNM",
      VU: "VUT",
      WF: "WLF",
      WS: "WSM",
      XK: "XKX",
      YE: "YEM",
      YT: "MYT",
      ZA: "ZAF",
      ZM: "ZMB",
      ZW: "ZWE"
    };
    var c = n => ({
        ...a[n],
        iso2: n,
        iso3: r[n]
      }),
      t = () => Object.keys(a).map(n => c(n));
    var g = t(),
      m = n => {
        let e = `${n}`.trim().replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d"),
          i = new RegExp(`^${e}$`, "i");
        return g.find(({
          name: o,
          native: l
        }) => i.test(o) || i.test(l))?.iso2 || !1;
      };

    const containsNonLatinCharactersFieldError = str => {
      const nonLatinRegex = /[^\u0000-\u017F]+/;
      return nonLatinRegex.test(str || '');
    };
    const validateNotContainsNonLatinCharacters = str => {
      if (containsNonLatinCharactersFieldError(str)) {
        return {
          isValid: false,
          error: ErrorTypes.nonLatinCharacters
        };
      }
      return {
        isValid: true
      };
    };
    function validateMaxLength(str, maxLength) {
      if (str.length > maxLength) {
        return {
          isValid: false,
          error: ErrorTypes.maxLengthExceeded
        };
      }
      return {
        isValid: true
      };
    }
    function validateMinLength(str, minLength) {
      if (str.length < minLength) {
        return {
          isValid: false,
          error: ErrorTypes.minLength
        };
      }
      return {
        isValid: true
      };
    }
    function validateNoNumbers(str) {
      const numberRegex = /\d/;
      if (numberRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.containsNumbers
        };
      }
      return {
        isValid: true
      };
    }
    function validateNoSpecialChars(str) {
      const specialCharsRegex = /[%_;|]/;
      if (specialCharsRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.containsSpecialChars
        };
      }
      return {
        isValid: true
      };
    }
    function validateNotEmpty(str) {
      const withoutWhiteSpace = str.replace(/\s/g, '');
      if (withoutWhiteSpace.length <= 0) return {
        isValid: false,
        error: ErrorTypes.empty
      };
      return {
        isValid: true
      };
    }
    function validateMaxDate(inputTimestamp, limitTimestamp) {
      if (inputTimestamp > limitTimestamp) {
        return {
          isValid: false,
          error: ErrorTypes.maxDate
        };
      }
      return {
        isValid: true
      };
    }
    function validateDate(ts) {
      return !ts ? {
        isValid: false,
        error: ErrorTypes.invalidDate
      } : {
        isValid: true
      };
    }
    function validateEmail(str) {
      if (!str || str.trim().length === 0) {
        return {
          isValid: false,
          error: ErrorTypes.empty
        };
      }
      if (!emailRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.invalidEmail
        };
      }
      return {
        isValid: true
      };
    }

    const DateFormat$1 = window.PoleneLibs.DateFormat;
    class InputValidation {
      inputs = {};
      dateFormat = new DateFormat$1();
      hasSubmitOnce = false;
      constructor({
        formContainer,
        inputs
      }) {
        this.formContainer = formContainer;
        this.inputs = inputs;
        this.form = this.formContainer.querySelector('form');
        if (!this.form) throw new Error('Form not found');
        this.submitButton = this.form.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        if (!this.submitButton) throw new Error('Submit Button not found');
      }
      triggerValidationEffect(input, validation) {
        if (!validation.isValid && validation.error) {
          this.displayErrorSpan(input, validation.error, validation.message);
          if (this.submitButton) this.submitButton.disabled = true;
          return false;
        }
        this.removeErrorSpan(input);
        if (this.submitButton) this.submitButton.disabled = false;
        return true;
      }
      displayErrorSpan(input, error, message) {
        this.removeErrorSpan(input);
        const errorSpan = this.form?.querySelector(`span[data-ref=${input.id}-${error}]`);
        if (!errorSpan) return;
        if (message) errorSpan.textContent = message;
        input.ariaInvalid = 'true';
        input.setAttribute('aria-describedby', `${input.id}-${error}`);
        errorSpan.hidden = false;
        errorSpan.style.display = 'block';
      }
      removeErrorSpan(input) {
        const errorSpans = this.form?.querySelectorAll(`span[data-ref^=${input.id}]`);
        if (!errorSpans) return;
        input.ariaInvalid = 'false';
        input.removeAttribute('aria-describedby');
        errorSpans.forEach(span => {
          span.hidden = true;
          span.style.display = 'none';
        });
      }
      checkRequiredInput({
        input
      }) {
        if (!input) return true;
        let inputIsEmpty = false;
        if (!input.validationConfig.required) return;
        const emptyCheck = validateNotEmpty(input.selector.value);
        if (!this.triggerValidationEffect(input.selector, emptyCheck)) return false;
        inputIsEmpty = true;
        return inputIsEmpty;
      }
      checkRequiredInputs({
        inputs
      }) {
        if (!inputs) return false;
        let isValid = true;
        Object.values(this.inputs).forEach(input => {
          if (!input.validationConfig.required) return;
          const emptyCheck = validateNotEmpty(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, emptyCheck)) {
            isValid = false;
          }
        });
        return isValid;
      }
      validateInput(input) {
        if (this.hasSubmitOnce) {
          const empty = validateNotEmpty(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, empty)) {
            return false;
          }
        }
        if (input.selector.dataset.ref == 'input-date' && input.selector.value != `${this.dateFormat.placeholder}  (${input.selector.dataset.tOptional})`) {
          const date = this.dateFormat.parse(input.selector.value);
          const invalidDateCheck = validateDate(date);
          if (!this.triggerValidationEffect(input.selector, invalidDateCheck)) return false;
          if (input.validationConfig.maxDate) {
            const maxDateCheck = validateMaxDate(date ?? NaN, input.validationConfig.maxDate);
            if (!this.triggerValidationEffect(input.selector, maxDateCheck)) return false;
          }
        }
        if (input.validationConfig.noSpecialChar) {
          const speCharCheck = validateNoSpecialChars(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, speCharCheck)) {
            return false;
          }
        }
        if (input.validationConfig.noNumber) {
          const noNumb = validateNoNumbers(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, noNumb)) {
            return false;
          }
        }
        if (input.validationConfig.maxLength) {
          const lengthCheck = validateMaxLength(input.selector.value, input.validationConfig.maxLength);
          if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
            return false;
          }
        }
        if (input.validationConfig.minLength) {
          const lengthCheck = validateMinLength(input.selector.value, input.validationConfig.minLength);
          if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
            return false;
          }
        }
        if (input.validationConfig.nonLatinCharacters) {
          const latinCharactersCheck = validateNotContainsNonLatinCharacters(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, latinCharactersCheck)) {
            return false;
          }
        }
        if (input.validationConfig.email) {
          const emailCheck = validateEmail(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, emailCheck)) {
            return false;
          }
        }
        return true;
      }
      validateForm({
        inputs
      }) {
        let isValid = true;
        Object.values(inputs).forEach(input => {
          if (input.selector.value.trim() !== '') {
            if (!this.validateInput(input)) {
              isValid = false;
            }
          }
        });
        return isValid;
      }
    }

    class PhoneInput {
      constructor({
        formContainer,
        phoneInput
      }) {
        this.formContainer = formContainer;
        this.form = this.formContainer.querySelector('form');
        if (!this.form) throw new Error('Form not found');
        this.phoneCountrySelect = this.form.querySelector(FormSelectors.Customer.PHONE_COUNTRY_SELECT);
        this.phoneInput = phoneInput;
        if (!this.phoneCountrySelect || !this.phoneInput) throw new Error('Element not found');
        const countrySelect = this.form.querySelector(FormSelectors.Customer.Address.COUNTRY_SELECT);
        this.defaultCountryCode = countrySelect && countrySelect.value ? m(countrySelect.value) : this.phoneCountrySelect[this.phoneCountrySelect.selectedIndex].dataset.country_code;
        this.inputValidation = new InputValidation({
          formContainer: this.formContainer,
          inputs: {
            phone: {
              selector: this.phoneInput,
              validationConfig: FormValidations.phone
            }
          }
        });
        if (this.phoneInput.value !== '') {
          this.handlePhoneNumberChange();
        }
        this.init();
      }
      handlePhoneCountryChange = () => {
        const countryCode = this.phoneCountrySelect[this.phoneCountrySelect.selectedIndex].dataset.country_code;
        if (!countryCode) return;
        this.defaultCountryCode = countryCode;
        this.updatePhoneFlag({
          countryCode: countryCode
        });
        this.updatePhoneNumberInput(countryCode);
      };
      handlePhoneNumberChange = () => {
        if (!this.phoneInput.value && !this.defaultCountryCode) return;
        let phoneNumberIsValid = true;
        if (this.phoneInput.value !== '') {
          try {
            const phoneNumber = parsePhoneNumber(this.phoneInput.value, this.defaultCountryCode);
            if (phoneNumber) {
              phoneNumberIsValid = isValidPhoneNumber(phoneNumber.number);
              if (phoneNumber.country) {
                this.defaultCountryCode = phoneNumber.country;
                this.updatePhoneFlag({
                  countryCode: phoneNumber.country
                });
                this.updatePhoneCountrySelect(phoneNumber.number);
              } else {
                phoneNumberIsValid = false;
              }
            }
            if (!phoneNumber) {
              phoneNumberIsValid = false;
            }
          } catch {
            phoneNumberIsValid = false;
          }
        }
        this.inputValidation.triggerValidationEffect(this.phoneInput, {
          isValid: phoneNumberIsValid,
          error: ErrorTypes.phoneNumberInvalid
        });
      };
      addPhoneCodeToPhoneCountrySelect = () => {
        try {
          Array.from(this.phoneCountrySelect.options).forEach(country => {
            const countryCode = country.dataset.country_code;
            if (countryCode && isSupportedCountry(countryCode)) {
              const callingCode = getCountryCallingCode(countryCode);
              country.innerText += ` (+${callingCode})`;
            } else {
              country.remove();
            }
          });
        } catch {
          throw new Error('Error updating phone country select');
        }
      };
      updatePhoneNumberInput = countryCode => {
        let phoneNumberIsValid = true;
        try {
          const currentPhoneNumber = parsePhoneNumber(this.phoneInput.value || '', countryCode);
          if (currentPhoneNumber) {
            const newPhoneNumber = parsePhoneNumber(currentPhoneNumber.nationalNumber || '', countryCode);
            if (newPhoneNumber) {
              phoneNumberIsValid = isValidPhoneNumber(newPhoneNumber.number);
              this.phoneInput.value = newPhoneNumber.formatInternational();
            }
          }
        } catch {
          phoneNumberIsValid = false;
        }
        this.inputValidation.triggerValidationEffect(this.phoneInput, {
          isValid: phoneNumberIsValid,
          error: ErrorTypes.phoneNumberInvalid
        });
      };
      updatePhoneCountrySelect = _phoneNumber => {
        let phoneNumberIsValid = true;
        try {
          const phoneNumber = parsePhoneNumber(_phoneNumber, this.defaultCountryCode);
          if (phoneNumber) {
            this.phoneInput.value = phoneNumber.formatInternational();
            if (!phoneNumber.country) return;
            this.selectCountryOption();
            this.updatePhoneFlag({
              countryCode: phoneNumber.country
            });
          }
        } catch {
          phoneNumberIsValid = false;
        }
        this.inputValidation.triggerValidationEffect(this.phoneInput, {
          isValid: phoneNumberIsValid,
          error: ErrorTypes.phoneNumberInvalid
        });
      };
      updatePhoneFlag = ({
        countryCode
      }) => {
        const flagToDisplay = this.form?.querySelector(`[data-ref="flag-${countryCode}"]`);
        const selectedFlagElement = this.form?.querySelector('#selected-flag img');
        if (!flagToDisplay || !selectedFlagElement) throw new Error('Error when updating flag');
        selectedFlagElement.src = flagToDisplay.src;
      };
      selectCountryOption = () => {
        const selectedCountryIndex = Array.from(this.phoneCountrySelect.options).findIndex(option => option.dataset.country_code === this.defaultCountryCode);
        if (selectedCountryIndex !== -1) this.phoneCountrySelect.selectedIndex = selectedCountryIndex;
      };
      init() {
        this.addPhoneCodeToPhoneCountrySelect();
        this.phoneCountrySelect.addEventListener('change', this.handlePhoneCountryChange);
        this.phoneInput?.addEventListener('blur', this.handlePhoneNumberChange);
        if (this.phoneInput.value) this.updatePhoneCountrySelect(this.phoneInput.value);
      }
      destroy() {
        this.phoneCountrySelect.removeEventListener('change', this.handlePhoneCountryChange);
        this.phoneInput?.removeEventListener('blur', this.handlePhoneNumberChange);
      }
    }

    class CustomerForm {
      hasSubmitOnce = false;
      constructor({
        formContainerId
      }) {
        this.formContainer = document.querySelector(formContainerId);
        if (!this.formContainer) throw new Error('Form Container not found');
      }
      initInputValidation({
        inputs
      }) {
        this.inputValidation = new InputValidation({
          formContainer: this.formContainer,
          inputs: inputs
        });
      }
      initPhoneInput({
        phoneInput
      }) {
        this.phoneInputClass = new PhoneInput({
          formContainer: this.formContainer,
          phoneInput: phoneInput
        });
      }
      setHasSubmitOnce({
        hasSubmitOnce
      }) {
        this.hasSubmitOnce = hasSubmitOnce;
        if (this.inputValidation) this.inputValidation.hasSubmitOnce = hasSubmitOnce;
      }
      destroy() {
        if (this.phoneInputClass) this.phoneInputClass.destroy();
      }
    }

    class RegisterForm extends CustomerForm {
      inputs = {};
      constructor({
        formId
      }) {
        super({
          formContainerId: `#${formId}`
        });
        this.registerFormContainer = document.getElementById(formId);
        if (!this.registerFormContainer) throw `Unable to find form container with id: ${formId}`;
        this.registerForm = this.registerFormContainer.querySelector('form');
        if (!this.registerForm) throw `Unable to find form in the given container: ${formId}`;
        this.phoneInput = this.registerFormContainer.querySelector(FormSelectors.Customer.PHONE);
        this.submitButton = this.registerForm.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        if (!this.phoneInput || !this.submitButton) throw new Error('Required elements not found');
        this.inputs = {
          civility: {
            selector: this.registerForm.querySelector(FormSelectors.Customer.CIVILITY),
            validationConfig: FormValidations.civility
          },
          firstName: {
            selector: this.registerForm.querySelector(FormSelectors.Customer.FIRST_NAME),
            validationConfig: FormValidations.firstName
          },
          lastName: {
            selector: this.registerForm.querySelector(FormSelectors.Customer.LAST_NAME),
            validationConfig: FormValidations.lastName
          },
          email: {
            selector: this.registerForm.querySelector(FormSelectors.Customer.EMAIL),
            validationConfig: FormValidations.email
          },
          password: {
            selector: this.registerForm.querySelector(FormSelectors.Customer.PASSWORD),
            validationConfig: FormValidations.password
          }
        };
        if (!window.P1?.themeSettings?.customerAccount?.storefrontToken) throw new Error('Storefront token not found');
        this.init();
      }
      handleFormValidation = () => {
        if (!this.inputs.civility?.selector || !this.inputs.firstName?.selector || !this.inputs.lastName?.selector || !this.inputs.password?.selector || !this.phoneInput) return false;
        const isValid = this.inputValidation?.validateForm({
          inputs: this.inputs
        });
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      handleInputValidation = input => {
        if (!input.selector || !input.validationConfig) return false;
        const isValid = this.inputValidation?.validateInput(input);
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      async handleFormSubmit(event) {
        event.preventDefault();
        this.setHasSubmitOnce({
          hasSubmitOnce: true
        });
        if (!this.inputValidation?.checkRequiredInputs({
          inputs: this.inputs
        }) || !this.handleFormValidation()) return false;
        const form = event.currentTarget;
        const formData = new FormData(form);
        const phoneFormData = formData.get('phone');
        let phoneNumber;
        if (phoneFormData && phoneFormData !== '') {
          phoneNumber = parsePhoneNumber(phoneFormData)?.number;
          if (phoneNumber) {
            formData.set('phone', phoneNumber);
          }
        }
        if (this.submitButton) this.submitButton.disabled = true;
        const storefrontToken = window.P1?.themeSettings?.customerAccount?.storefrontToken;
        if (!storefrontToken) throw new Error('Storefront token not found');
        const customerCreateHandler = await handleCreateCustomer(formData, storefrontToken);
        if (this.submitButton) {
          if (!customerCreateHandler.customerIsCreated) {
            this.inputValidation?.triggerValidationEffect(this.submitButton, {
              isValid: customerCreateHandler.customerIsCreated,
              error: customerCreateHandler.errorType,
              message: customerCreateHandler.errorMessage
            });
          }
          this.submitButton.disabled = !customerCreateHandler.customerIsCreated;
        }
      }
      init() {
        this.initInputValidation({
          inputs: this.inputs
        });
        this.initPhoneInput({
          phoneInput: this.phoneInput
        });
        this.registerForm.addEventListener('submit', this.handleFormSubmit.bind(this));
        Object.values(this.inputs).forEach(input => input.selector.addEventListener('blur', () => this.handleInputValidation(input)));
      }
      destroy() {
        this.registerForm.removeEventListener('submit', this.handleFormSubmit.bind(this));
        Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', () => this.handleInputValidation(input)));
      }
    }
    var customerRegisterForm = async () => {
      const registerFormElement = document.getElementById('register-form');
      if (registerFormElement) {
        try {
          const registerForm = new RegisterForm({
            formId: 'register-form'
          });
          return () => {
            registerForm.destroy();
          };
        } catch (error) {}
      }
    };

    var customerRegisterForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: customerRegisterForm
    });

    const {
      getClientToken
    } = window.PoleneLibs.Utils;
    const captureCustomerIdentity = async ({
      email,
      source
    }) => {
      if (!email) return;
      try {
        const clientToken = getClientToken();
        const cartToken = await getCartToken();
        const body = {
          email,
          source
        };
        if (clientToken) body.client_token = clientToken;
        if (cartToken) body.cart_token = cartToken;
        await fetch(API_PROXY.CUSTOMER_IDENTITY, {
          method: 'POST',
          keepalive: true,
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        });
      } catch {}
    };

    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    class LoginForm extends CustomerForm {
      inputs = {};
      constructor({
        formId
      }) {
        super({
          formContainerId: `#${formId}`
        });
        this.loginFormContainer = document.getElementById(formId);
        if (!this.loginFormContainer) throw new Error('Form not found');
        this.loginFormContainer.style.display = 'block';
        this.loginFormContainer.classList.add('is-revealed');
        this.loginForm = this.loginFormContainer.querySelector('form');
        this.loginForm.noValidate = true;
        this.submitButton = this.loginForm.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        this.inputs = {
          email: {
            selector: this.loginForm.querySelector(FormSelectors.Customer.Shopify.Selectors.EMAIL),
            validationConfig: FormValidations.email
          },
          password: {
            selector: this.loginForm.querySelector(FormSelectors.Customer.Shopify.Selectors.PASSWORD),
            validationConfig: FormValidations.password
          }
        };
        this.init();
      }
      handleInputValidation = input => {
        if (!input) {
          return false;
        }
        const isValid = this.inputValidation?.checkRequiredInput({
          input: input
        });
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      handleFormSubmit = async event => {
        event.preventDefault();
        if (!this.inputs.email || !this.inputs.password) {
          return false;
        }
        const isValid = this.inputValidation?.checkRequiredInputs({
          inputs: this.inputs
        });
        if (this.submitButton) this.submitButton.disabled = !isValid;
        if (isValid) {
          if (window.location.search) {
            this.loginForm.action += window.location.search.includes('wk-redirect') ? `?return_url=${encodeURIComponent(REDIRECT_URL.WISHLIST)}` : window.location.search;
          }
          const email = this.inputs.email?.selector?.value || '';
          dispatchEvent(window, 'CUSTOMER_LOGIN', {
            email
          });
          await captureCustomerIdentity({
            email,
            source: 'login'
          });
          this.loginForm.submit();
        }
        return isValid;
      };
      init() {
        this.initInputValidation({
          inputs: this.inputs
        });
        Object.values(this.inputs).forEach(input => input.selector.addEventListener('blur', () => this.handleInputValidation(input)));
        this.loginForm.addEventListener('submit', event => this.handleFormSubmit(event));
      }
      destroyAddressForm() {
        Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', () => this.handleInputValidation(input)));
        this.loginForm.addEventListener('submit', event => this.handleFormSubmit(event));
      }
    }
    var customerLoginForm = async () => {
      const loginFormElement = document.getElementById('login-form');
      if (loginFormElement) {
        try {
          const loginForm = new LoginForm({
            formId: 'login-form'
          });
          return () => {
            loginForm.destroy();
          };
        } catch (error) {}
      }
    };

    var customerLoginForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: customerLoginForm
    });

    class ActivateForm extends CustomerForm {
      inputs = {};
      constructor({
        formId
      }) {
        super({
          formContainerId: `#${formId}`
        });
        this.activateFormContainer = document.getElementById(formId);
        if (!this.activateFormContainer) throw new Error('Form not found');
        this.activateFormContainer.style.display = 'block';
        this.activateFormContainer.classList.add('is-revealed');
        this.activateForm = this.activateFormContainer.querySelector('form');
        this.activateForm.noValidate = true;
        this.submitButton = this.activateForm.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        this.inputs = {
          password: {
            selector: this.activateForm.querySelector(FormSelectors.Customer.Shopify.Selectors.PASSWORD),
            validationConfig: FormValidations.password
          },
          confirmPassword: {
            selector: this.activateForm.querySelector(FormSelectors.Customer.Shopify.Selectors.CONFIRM_PASSWORD),
            validationConfig: FormValidations.confirmPassword
          }
        };
        this.init();
      }
      handleFormValidation = () => {
        if (!this.inputs.password || !this.inputs.confirmPassword) {
          return false;
        }
        const isValid = this.inputValidation?.validateForm({
          inputs: this.inputs
        });
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      init() {
        this.initInputValidation({
          inputs: this.inputs
        });
        Object.values(this.inputs).forEach(input => input.selector.addEventListener('blur', this.handleFormValidation));
      }
      destroyAddressForm() {
        Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', this.handleFormValidation));
      }
    }
    var customerActivateForm = async () => {
      const activateFormElement = document.getElementById('activate-form');
      if (activateFormElement) {
        try {
          const activateForm = new ActivateForm({
            formId: 'activate-form'
          });
          return () => {
            activateForm.destroy();
          };
        } catch (error) {}
      }
    };

    var customerActivateForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: customerActivateForm
    });

    class ResetPasswordForm extends CustomerForm {
      inputs = {};
      constructor({
        formId
      }) {
        super({
          formContainerId: `#${formId}`
        });
        this.resetPasswordFormContainer = document.getElementById(formId);
        if (!this.resetPasswordFormContainer) throw new Error('Form not found');
        this.resetPasswordFormContainer.style.display = 'block';
        this.resetPasswordFormContainer.classList.add('is-revealed');
        this.resetPasswordForm = this.resetPasswordFormContainer.querySelector('form');
        this.resetPasswordForm.noValidate = true;
        this.submitButton = this.resetPasswordForm.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        this.inputs = {
          password: {
            selector: this.resetPasswordForm.querySelector(FormSelectors.Customer.Shopify.Selectors.PASSWORD),
            validationConfig: FormValidations.password
          },
          confirmPassword: {
            selector: this.resetPasswordForm.querySelector(FormSelectors.Customer.Shopify.Selectors.CONFIRM_PASSWORD),
            validationConfig: FormValidations.confirmPassword
          }
        };
        this.init();
      }
      handleFormValidation = () => {
        if (!this.inputs.password || !this.inputs.confirmPassword) {
          return false;
        }
        const requiredInputs = this.inputValidation?.checkRequiredInputs({
          inputs: this.inputs
        });
        if (!requiredInputs) return false;
        const isValid = this.inputValidation?.validateForm({
          inputs: this.inputs
        });
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      handleFormSubmit = event => {
        event.preventDefault();
        if (this.handleFormValidation()) {
          this.resetPasswordForm.submit();
        }
      };
      init() {
        this.initInputValidation({
          inputs: this.inputs
        });
        Object.values(this.inputs).forEach(input => input.selector.addEventListener('blur', this.handleFormValidation));
        this.resetPasswordForm.addEventListener('submit', this.handleFormSubmit);
      }
      destroyResetPasswordForm() {
        Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', this.handleFormValidation));
        this.resetPasswordForm.removeEventListener('submit', this.handleFormSubmit);
      }
    }
    var customerResetPassword = async () => {
      const resetPasswordFormElement = document.getElementById('reset-password-form');
      if (resetPasswordFormElement) {
        try {
          const resetPasswordForm = new ResetPasswordForm({
            formId: 'reset-password-form'
          });
          return () => {
            resetPasswordForm.destroy();
            resetPasswordForm.destroyResetPasswordForm();
          };
        } catch (error) {}
      }
    };

    var customerResetPassword$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: customerResetPassword
    });

    class RecoverPasswordForm extends CustomerForm {
      inputs = {};
      constructor({
        formId
      }) {
        super({
          formContainerId: `#${formId}`
        });
        this.recoverPasswordFormContainer = document.getElementById(formId);
        if (!this.recoverPasswordFormContainer) throw new Error('Form not found');
        this.recoverPasswordFormContainer.style.display = 'block';
        this.recoverPasswordFormContainer.classList.add('is-revealed');
        this.recoverPasswordForm = this.recoverPasswordFormContainer.querySelector('form');
        this.recoverPasswordForm.noValidate = true;
        this.submitButton = this.recoverPasswordForm.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        this.inputs = {
          email: {
            selector: this.recoverPasswordForm.querySelector(FormSelectors.Customer.RecoverPassword.EMAIL),
            validationConfig: FormValidations.email
          }
        };
        this.init();
      }
      handleFormValidation = () => {
        if (!this.inputs.email) {
          return false;
        }
        const requiredInputs = this.inputValidation?.checkRequiredInputs({
          inputs: this.inputs
        });
        if (!requiredInputs) return false;
        const isValid = this.inputValidation?.validateForm({
          inputs: this.inputs
        });
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      handleFormSubmit = event => {
        event.preventDefault();
        if (this.handleFormValidation()) {
          this.recoverPasswordForm.submit();
        }
      };
      init() {
        this.initInputValidation({
          inputs: this.inputs
        });
        Object.values(this.inputs).forEach(input => input.selector.addEventListener('blur', this.handleFormValidation));
        this.recoverPasswordForm.addEventListener('submit', this.handleFormSubmit);
      }
      destroyRecoverPasswordForm() {
        Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', this.handleFormValidation));
        this.recoverPasswordForm.removeEventListener('submit', this.handleFormSubmit);
      }
    }
    var customerRecoverPassword = async () => {
      const recoverPasswordFormElement = document.getElementById('customer-recover-password-form');
      if (recoverPasswordFormElement) {
        try {
          const recoverPasswordForm = new RecoverPasswordForm({
            formId: 'customer-recover-password-form'
          });
          return () => {
            recoverPasswordForm.destroy();
            recoverPasswordForm.destroyRecoverPasswordForm();
          };
        } catch (error) {}
      }
    };

    var customerRecoverPassword$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: customerRecoverPassword
    });

    class AddressForm extends CustomerForm {
      inputs = {};
      constructor({
        formId
      }) {
        super({
          formContainerId: `#${formId}`
        });
        this.addressFormContainer = document.getElementById(formId);
        if (!this.addressFormContainer) throw new Error('Form not found');
        this.addressFormContainer.style.display = 'block';
        this.addressFormContainer.classList.add('is-revealed');
        this.addressForm = this.addressFormContainer.querySelector('form');
        this.addressForm.noValidate = true;
        this.phoneInput = this.addressFormContainer.querySelector(FormSelectors.Customer.Address.PHONE);
        if (!this.phoneInput) throw new Error('Phone Element not found');
        this.submitButton = this.addressForm.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        this.inputs = {
          firstName: {
            selector: this.addressForm.querySelector(FormSelectors.Customer.Address.FIRST_NAME),
            validationConfig: FormValidations.firstName
          },
          lastName: {
            selector: this.addressForm.querySelector(FormSelectors.Customer.Address.LAST_NAME),
            validationConfig: FormValidations.lastName
          },
          address1: {
            selector: this.addressForm.querySelector(FormSelectors.Customer.Address.ADDRESS_1),
            validationConfig: FormValidations.address1
          },
          address2: {
            selector: this.addressForm.querySelector(FormSelectors.Customer.Address.ADDRESS_2),
            validationConfig: FormValidations.address2
          },
          zip: {
            selector: this.addressForm.querySelector(FormSelectors.Customer.Address.ZIP),
            validationConfig: FormValidations.zip
          },
          city: {
            selector: this.addressForm.querySelector(FormSelectors.Customer.Address.CITY),
            validationConfig: FormValidations.city
          }
        };
        this.init();
      }
      handleFormValidation = () => {
        if (!this.inputs.firstName || !this.inputs.lastName || !this.inputs.address1 || !this.inputs.zip || !this.inputs.city || !this.phoneInput) {
          return false;
        }
        const isValid = this.inputValidation?.validateForm({
          inputs: this.inputs
        });
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      handleFormSubmit = async e => {
        e.preventDefault();
        this.setHasSubmitOnce({
          hasSubmitOnce: true
        });
        if (!this.inputValidation?.checkRequiredInputs({
          inputs: this.inputs
        }) || !this.handleFormValidation) return false;
        const form = e.currentTarget;
        const formData = new FormData(form);
        try {
          await fetch(form.action, {
            method: 'POST',
            headers: {
              Accept: 'application/json, text/html'
            },
            body: formData
          });
          const currentUrl = window.location.href.split('?')[0];
          window.location.href = currentUrl;
        } catch (error) {}
      };
      init() {
        this.initPhoneInput({
          phoneInput: this.phoneInput
        });
        this.initInputValidation({
          inputs: this.inputs
        });
        this.addressForm?.addEventListener('submit', this.handleFormSubmit);
        Object.values(this.inputs).forEach(input => input.selector.addEventListener('blur', this.handleFormValidation));
      }
      destroyAddressForm() {
        this.addressForm?.removeEventListener('submit', this.handleFormSubmit);
        Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', this.handleFormValidation));
      }
    }
    var customerAddressForm = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const view = urlParams.get('view');
      const id = urlParams.get('id');
      let formId;
      if (id) formId = `address_form_${id}`;else formId = 'address_form';
      if (view === 'edit' || view === 'add') {
        try {
          const addressForm = new AddressForm({
            formId: formId
          });
          return () => {
            addressForm.destroy();
            addressForm.destroyAddressForm();
          };
        } catch (error) {}
      }
    };

    var customerAddressForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: customerAddressForm
    });

    const events = window.PoleneLibs.Events.default;
    const DateFormat = window.PoleneLibs.DateFormat;
    const {
      storeLanguage
    } = window.PoleneLibs.ConstantsDate;
    class CustomerUpdateForm extends CustomerForm {
      inputs = {};
      dateFormat = new DateFormat();
      constructor({
        containerId
      }) {
        super({
          formContainerId: containerId
        });
        this.updateCustomerFormContainer = document.querySelector(containerId);
        if (!this.updateCustomerFormContainer) throw new Error('Form Container not found');
        this.updateCustomerForm = this.updateCustomerFormContainer.querySelector('form');
        if (!this.updateCustomerForm) throw new Error('Form not found');
        this.updateCustomerFormContainer.style.display = 'block';
        this.updateCustomerFormContainer.classList.add('is-revealed');
        this.updateCustomerForm.noValidate = true;
        this.smsInputContainer = this.updateCustomerForm.querySelector('.sms-marketing-consent');
        this.phoneInput = this.updateCustomerForm.querySelector(FormSelectors.Customer.PHONE);
        this.submitButton = this.updateCustomerForm.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        this.updatedText = this.updateCustomerForm.querySelector('p[data-ref="profile-updated"]');
        if (!this.phoneInput || !this.submitButton) throw new Error('Elements not found');
        this.inputs = {
          civility: {
            selector: this.updateCustomerForm.querySelector(FormSelectors.Customer.CIVILITY),
            validationConfig: FormValidations.civility
          },
          firstName: {
            selector: this.updateCustomerForm.querySelector(FormSelectors.Customer.Update.Selectors.FIRST_NAME),
            validationConfig: FormValidations.firstName
          },
          lastName: {
            selector: this.updateCustomerForm.querySelector(FormSelectors.Customer.Update.Selectors.LAST_NAME),
            validationConfig: FormValidations.lastName
          },
          birthdate: {
            selector: this.updateCustomerForm.querySelector(FormSelectors.Customer.BIRTHDATE),
            validationConfig: FormValidations.birthdate
          }
        };
        this.init();
      }
      handleFormValidation = () => {
        if (!this.inputs.civility || !this.inputs.firstName || !this.inputs.lastName) return false;
        const isValid = this.inputValidation?.validateForm({
          inputs: this.inputs
        });
        if (this.submitButton && isValid) {
          this.inputValidation?.triggerValidationEffect(this.submitButton, {
            isValid: isValid,
            error: ErrorTypes.formSubmitError
          });
        }
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      handleFormSubmit = async event => {
        event.preventDefault();
        this.setHasSubmitOnce({
          hasSubmitOnce: true
        });
        if (!this.inputValidation?.checkRequiredInputs({
          inputs: this.inputs
        }) || !this.handleFormValidation) return false;
        const form = event.currentTarget;
        const formData = new FormData(form);
        formData.append('name', 'updateCustomer');
        formData.set('locale', storeLanguage);
        const phoneFormData = formData.get('phone');
        const birthdateFormData = formData.get('birthdate');
        if (phoneFormData && phoneFormData !== '') formData.set('phone', phoneFormData.toString().replaceAll(' ', ''));
        if (birthdateFormData && birthdateFormData !== '') {
          const birthdate = this.dateFormat.format(birthdateFormData.toString(), 'YYYY-MM-DD');
          formData.set('birthdate', birthdate ?? '');
        }
        if (this.submitButton) this.submitButton.disabled = true;
        if (this.updatedText) {
          this.updatedText.style.visibility = 'hidden';
          this.updatedText.ariaHidden = 'true';
        }
        try {
          let updateIsValid = true;
          const response = await fetch(`${API_PROXY.UPDATE_CUSTOMER}`, {
            method: 'POST',
            body: formData
          });
          if (!response.ok) updateIsValid = false;else if (this.updatedText) {
            this.updatedText.style.visibility = 'visible';
            this.updatedText.ariaHidden = 'false';
            if (formData.get('email_marketing_consent')) {
              const event = new CustomEvent(events.NEWSLETTER_SUBSCRIBED, {
                detail: {
                  source: 'profile_update'
                }
              });
              window.dispatchEvent(event);
            }
          }
          if (this.submitButton) {
            this.inputValidation?.triggerValidationEffect(this.submitButton, {
              isValid: updateIsValid,
              error: ErrorTypes.formSubmitError
            });
            this.submitButton.disabled = false;
          }
        } catch (error) {}
      };
      async getCustomerSmsConsent() {
        const response = await fetch(API_PROXY.CUSTOMER_SMS_CONSENT);
        if (response.ok) {
          const {
            smsMarketingConsent
          } = await response.json();
          if (smsMarketingConsent === null) {
            return;
          }
          if (this.smsInputContainer) {
            const smsInput = this.smsInputContainer.querySelector('#contact-by-sms-checkbox');
            if (smsInput) {
              smsInput.checked = smsMarketingConsent;
              this.smsInputContainer.classList.add('is-revealed');
            }
          }
        }
      }
      init() {
        this.getCustomerSmsConsent();
        this.initPhoneInput({
          phoneInput: this.phoneInput
        });
        this.initInputValidation({
          inputs: this.inputs
        });
        this.updateCustomerForm?.addEventListener('submit', this.handleFormSubmit);
        Object.values(this.inputs).forEach(input => input.selector.addEventListener('blur', this.handleFormValidation));
      }
      destroyCustomerUpdateForm() {
        this.updateCustomerForm?.removeEventListener('submit', this.handleFormSubmit);
        Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', this.handleFormValidation));
      }
    }
    var customerUpdateForm = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const view = urlParams.get('view');
      if (view === 'profile') {
        try {
          const customerUpdateForm = new CustomerUpdateForm({
            containerId: FormSelectors.Customer.Update.ID
          });
          return () => {
            customerUpdateForm.destroy();
            customerUpdateForm.destroyCustomerUpdateForm();
          };
        } catch (error) {}
      }
    };

    var customerUpdateForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: customerUpdateForm
    });

    const {
      getElementsByRef: getElementsByRef$1
    } = window.PoleneLibs.Refs;
    var customerChatButton = () => {
      const {
        chatButton
      } = getElementsByRef$1(['chat-button']);
      if (!chatButton) return;
      const buttons = Array.isArray(chatButton) ? chatButton : [chatButton];
      const openChatBox = () => {
        window?.zE?.('messenger', 'open');
      };
      const removeEventListener = () => {
        buttons.forEach(btn => btn.removeEventListener('click', openChatBox));
      };
      const setEventListener = () => {
        buttons.forEach(btn => btn.addEventListener('click', openChatBox));
      };
      const init = () => {
        setEventListener();
      };
      init();
      return removeEventListener;
    };

    var customerChatButton$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: customerChatButton
    });

    const {
      getElementByRef: getElementByRef$8
    } = window.PoleneLibs.Refs;
    class OrderReturnHistory {
      constructor() {
        this.orderHistoryContainer = getElementByRef$8('returns-history').returnsHistory;
        this.orderId = this.orderHistoryContainer?.getAttribute('data-order-id') ?? undefined;
        this.parentCardElement = this.orderHistoryContainer?.closest('.component-card-title');
        this.init();
      }
      async fetchReturnHistory() {
        const response = await fetch(`${API_PROXY.RETURNS}?order_id=${this.orderId}&locale=${window.Shopify?.locale}-${window.Shopify?.country}`);
        if (!response.ok) {
          throw new Error('Failed to fetch return history');
        }
        return await response.text();
      }
      async init() {
        if (!this.orderHistoryContainer || !this.orderId) {
          return;
        }
        const returns = await this.fetchReturnHistory();
        this.orderHistoryContainer.hidden = false;
        this.orderHistoryContainer.innerHTML = returns;
        this.parentCardElement?.classList.add('is-revealed');
      }
      destroy() {}
    }
    var returnHistory = async () => {
      try {
        const returnHistory = new OrderReturnHistory();
        return () => {
          returnHistory.destroy();
        };
      } catch (error) {}
    };

    var returnHistory$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: returnHistory
    });

    class ComponentReturnButton extends HTMLElement {
      controller = undefined;
      orderId = null;
      returnDays = null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.orderId = this.dataset.orderId || null;
        this.returnDays = this.dataset.returnDays || null;
        this.hidden = true;
        if (this.orderId) {
          this.init();
        } else {
          this.hidden = true;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      async fetchReturnButton() {
        const response = await fetch(`${API_PROXY.RETURN_BUTTON}?order_id=${this.orderId}&return_days=${this.returnDays}`, {
          signal: this.controller?.signal
        });
        if (!response.ok) {
          throw new Error('Failed to fetch return button');
        }
        return await response.text();
      }
      async init() {
        if (!this.orderId) {
          return;
        }
        try {
          const returns = await this.fetchReturnButton();
          if (returns && returns.trim()) {
            this.innerHTML = returns;
            this.hidden = false;
            this.classList.add('is-revealed');
          } else {
            this.hidden = true;
          }
        } catch (error) {
          if (error instanceof Error && error.name !== 'AbortError') ;
          this.hidden = true;
        }
      }
      static define() {
        if (!customElements.get('component-return-button')) {
          customElements.define('component-return-button', ComponentReturnButton);
        }
      }
    }
    ComponentReturnButton.define();
    var returnButton = () => {
      ComponentReturnButton.define();
    };

    var returnButton$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: returnButton
    });

    const {
      getElementByRef: getElementByRef$7
    } = window.PoleneLibs.Refs;
    class OrderDetails {
      constructor() {
        const {
          orderDetails
        } = getElementByRef$7('order-details');
        const {
          accountOverviewOrderDetails
        } = getElementByRef$7('account-overview-order-details');
        this.accountOrderDetailsContainer = accountOverviewOrderDetails;
        this.orderDetailsContainer = orderDetails;
        this.orderId = this.orderDetailsContainer?.getAttribute('data-order-id') ?? undefined;
        this.init();
      }
      async fetchOrderDetails() {
        const response = await fetch(`${API_PROXY.ORDER_DETAILS}?order_id=${this.orderId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch order details');
        }
        return await response.text();
      }
      async init() {
        if (!this.orderDetailsContainer || !this.orderId || !this.accountOrderDetailsContainer) {
          return;
        }
        const details = await this.fetchOrderDetails();
        if (!(details.trim() === '')) {
          this.orderDetailsContainer.innerHTML = details;
          this.accountOrderDetailsContainer.querySelector('.tracking-url')?.remove();
        }
        this.accountOrderDetailsContainer.classList.add('is-revealed');
        this.accountOrderDetailsContainer.setAttribute('aria-hidden', 'false');
      }
      destroy() {}
    }
    var orderDetails = async () => {
      try {
        const orderDetails = new OrderDetails();
        return () => {
          orderDetails.destroy();
        };
      } catch (error) {}
    };

    var orderDetails$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: orderDetails
    });

    const {
      getElementByRef: getElementByRef$6
    } = window.PoleneLibs.Refs;
    class CustomerDeletedAccount {
      constructor() {
        const {
          deletedAccount
        } = getElementByRef$6(['deleted-account']);
        this.deletedAccount = deletedAccount;
        if (this.deletedAccount) this.init();
      }
      destroy() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
      }
      init() {
        this.timeoutId = setTimeout(() => {
          this.logout();
        }, 3000);
      }
      logout() {
        fetch('/account/logout').then(() => {
          window.location.href = REDIRECT_URL.ACCOUNT;
        });
      }
    }
    var customerDeletedAccount = async () => {
      try {
        const customerDeletedAccount = new CustomerDeletedAccount();
        return () => {
          customerDeletedAccount.destroy();
        };
      } catch (error) {}
    };

    var customerDeletedAccount$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: customerDeletedAccount
    });

    class CustomerOrderHistory extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.render();
      }
      disconnectedCallback() {}
      async fetchOrderHistoryHTML() {
        const response = await fetch(`${API_PROXY.ORDER_HISTORY}`);
        if (!response.ok) {
          throw new Error('Failed to fetch order history');
        }
        return await response.text();
      }
      async render() {
        const ordersHTML = await this.fetchOrderHistoryHTML();
        this.innerHTML = ordersHTML;
      }
      static define = () => {
        if (!customElements.get('customer-order-history')) {
          customElements.define('customer-order-history', CustomerOrderHistory);
        }
      };
    }
    var customerOrderHistory = () => {
      CustomerOrderHistory.define();
    };

    var customerOrderHistory$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CustomerOrderHistory: CustomerOrderHistory,
        default: customerOrderHistory
    });

    class Bis {
      static getHTML = async signal => {
        try {
          const response = await fetch(API_PROXY.BIS_SUBSCRIPTIONS, {
            headers: {
              Accept: 'text/html'
            },
            signal
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          return await response.text();
        } catch (error) {
          if (error.name === 'AbortError') return '';
          return '';
        }
      };
      static unsubscribe = async (variantId, signal) => {
        try {
          const response = await fetch(API_PROXY.BIS_SUBSCRIPTIONS, {
            method: 'DELETE',
            headers: {
              Accept: 'text/html'
            },
            body: new URLSearchParams({
              variant_id: variantId
            }),
            signal
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          return await response.text();
        } catch (error) {
          if (error.name === 'AbortError') return '';
          return '';
        }
      };
    }

    const {
      getElementByRef: getElementByRef$5
    } = window.PoleneLibs.Refs;
    class BisProductCard extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = undefined;
      }
      updatedCallback() {
        this.refresh();
      }
      refresh() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.initializeElements();
        this.setupEventListeners();
      }
      initializeElements() {
        const {
          bisCancel
        } = getElementByRef$5('bis-cancel', this);
        this.cancelButton = bisCancel;
      }
      setupEventListeners() {
        const {
          signal
        } = this.controller;
        this.cancelButton?.addEventListener('click', this.handleCancel, {
          signal
        });
      }
      handleCancel = async () => {
        const variantId = this.dataset.variantId;
        if (!variantId) return;
        this.cancelButton?.setAttribute('disabled', '');
        const newGridHTML = await Bis.unsubscribe(variantId, this.controller?.signal);
        const grid = this.closest('bis-grid');
        if (grid) {
          grid.syncHTML(newGridHTML);
          this.remove();
        }
      };
      static define = () => {
        if (!customElements.get('bis-product-card')) {
          customElements.define('bis-product-card', BisProductCard);
        }
      };
    }
    var bisProductCard = () => {
      BisProductCard.define();
    };

    var bisProductCard$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: bisProductCard
    });

    const {
      getElementByRef: getElementByRef$4
    } = window.PoleneLibs.Refs;
    const {
      SSRComponent
    } = window.PoleneLibs.BaseComponent;
    class BisGrid extends SSRComponent {
      onMount() {
        const {
          bisContent,
          bisEmpty
        } = getElementByRef$4(['bis-content', 'bis-empty'], this);
        this.contentContainer = bisContent;
        this.emptyState = bisEmpty;
        this.renderGrid();
      }
      renderGrid = async () => {
        const html = await Bis.getHTML(this.controller?.signal);
        this.syncHTML(html);
      };
      static define = () => {
        if (!customElements.get('bis-grid')) customElements.define('bis-grid', BisGrid);
      };
    }
    var bisGrid = () => {
      BisGrid.define();
    };

    var bisGrid$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        BisGrid: BisGrid,
        default: bisGrid
    });

    const {
      getElementsByRef
    } = window.PoleneLibs.Refs;
    var fragmentAddressBlock = () => {
      const {
        addressDeleteForm
      } = getElementsByRef(['address-delete-form']);
      if (!addressDeleteForm) return;
      const forms = Array.isArray(addressDeleteForm) ? [...addressDeleteForm] : [addressDeleteForm];
      let modal;
      let cancel;
      let confirm;
      let deleteBtns = forms.map(form => form.querySelector('button[data-ref="address-delete-btn"]'));
      let modalFormId;
      const removeEventListener = () => {
        deleteBtns.forEach(btn => btn?.removeEventListener('click', openModal));
        forms.forEach(form => form.removeEventListener('submit', handleFormSubmit));
        cancel?.removeEventListener('click', closeModal);
        confirm?.removeEventListener('click', handleConfirm);
      };
      const setEventListener = () => {
        forms.forEach(form => form.addEventListener('submit', handleFormSubmit));
        deleteBtns.forEach(btn => btn?.addEventListener('click', openModal));
      };
      const init = () => {
        setEventListener();
      };
      const openModal = event => {
        modal = document.body.querySelector('component-modal[data-ref="address-delete-modal"]');
        if (!modal) return;
        modal?.open();
        cancel = modal.querySelector('button[data-ref="cancel"]');
        confirm = modal.querySelector('button[data-ref="confirm"]');
        if (!cancel || !confirm) return;
        cancel.addEventListener('click', closeModal);
        confirm.addEventListener('click', handleConfirm);
        modalFormId = event.target.id;
      };
      const closeModal = () => {
        if (modal) modal.close();
      };
      const handleConfirm = () => {
        const event = new Event('submit');
        const currForm = forms.find(form => form.id == modalFormId);
        currForm?.dispatchEvent(event);
      };
      const handleFormSubmit = async e => {
        e.preventDefault();
        const form = e.currentTarget;
        const formData = new FormData(form);
        try {
          await fetch(form.action, {
            method: 'POST',
            headers: {
              Accept: 'application/json, text/html'
            },
            body: formData
          });
          window.location.reload();
        } catch (error) {}
      };
      init();
      return removeEventListener;
    };

    var fragmentAddressBlock$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentAddressBlock
    });

    const {
      getElementByRef: getElementByRef$3
    } = window.PoleneLibs.Refs;
    var fragmentProfile = () => {
      const {
        customerForm
      } = getElementByRef$3(['customer-form']);
      if (!customerForm) return;
      let modal;
      let cancel;
      let confirm;
      let deleteBtn = customerForm.querySelector('button[data-ref="account-delete-btn"]');
      const removeEventListener = () => {
        deleteBtn?.removeEventListener('click', openModal);
        cancel?.removeEventListener('click', closeModal);
        confirm?.removeEventListener('click', handleConfirm);
      };
      const setEventListener = () => {
        deleteBtn?.addEventListener('click', openModal);
      };
      const init = () => {
        setEventListener();
      };
      const openModal = () => {
        modal = document.body.querySelector('component-modal[data-ref="account-delete-modal"]');
        if (!modal) return;
        modal?.open();
        cancel = modal.querySelector('button[data-ref="cancel"]');
        confirm = modal.querySelector('button[data-ref="confirm"]');
        if (!cancel || !confirm) return;
        cancel.addEventListener('click', closeModal);
        confirm.addEventListener('click', handleConfirm);
      };
      const closeModal = () => {
        if (modal) modal.close();
      };
      const handleConfirm = async () => {
        const res = await fetch(API_PROXY.DELETE_ACCOUNT);
        if (res.ok) logout();
      };
      const logout = () => {
        fetch('/account/logout').then(() => window.location.href = '/account');
      };
      init();
      return removeEventListener;
    };

    var fragmentProfile$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentProfile
    });

    const {
      getElementByRef: getElementByRef$2
    } = window.PoleneLibs.Refs;
    class ComponentPasswordInput extends HTMLElement {
      visibilityState = true;
      constructor() {
        super();
      }
      connectedCallback() {
        if (this.setElements()) {
          this.setEventListener();
        }
      }
      disconnectedCallback() {
        if (this.toggleElements?.button) {
          this.toggleElements.button.removeEventListener('click', () => this.updateToggleState());
        }
      }
      setElements() {
        const {
          toggleButton,
          toggleOn,
          toggleOff,
          passwordInput
        } = getElementByRef$2(['toggle-button', 'toggle-on', 'toggle-off', 'password-input'], this);
        if (!toggleButton || !toggleOff || !toggleOn || !passwordInput) return false;
        this.toggleElements = {
          button: toggleButton,
          on: toggleOn,
          off: toggleOff
        };
        this.passwordInput = passwordInput;
        return true;
      }
      setEventListener() {
        if (this.toggleElements) {
          this.toggleElements.button.addEventListener('click', () => this.updateToggleState());
        }
      }
      updateToggleState() {
        this.visibilityState = !this.visibilityState;
        this.toggleElements?.button.setAttribute('aria-pressed', !this.visibilityState ? 'true' : 'false');
        this.toggleElements?.button.setAttribute('aria-labelledby', this.visibilityState ? this.toggleElements?.on?.getAttribute('id') || 'toggle-on' : this.toggleElements?.off?.getAttribute('id') || 'toggle-off');
        this.togglePasswordVisibility();
      }
      togglePasswordVisibility() {
        if (this.passwordInput) {
          this.passwordInput.setAttribute('type', this.visibilityState ? 'password' : 'text');
          this.updateToggleIcon();
        }
      }
      updateToggleIcon() {
        if (this.toggleElements) {
          this.toggleElements.on.classList.toggle('active', !this.visibilityState);
          this.toggleElements.off.classList.toggle('active', this.visibilityState);
        }
      }
      static define() {
        if (!customElements.get('component-password-input')) {
          customElements.define('component-password-input', ComponentPasswordInput);
        }
      }
    }
    var componentPasswordInput = () => {
      ComponentPasswordInput.define();
    };

    var componentPasswordInput$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentPasswordInput
    });

    const {
      isMobile
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$1
    } = window.PoleneLibs.Refs;
    class ComponentCustomerNav extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {}
      init() {
        const {
          customerNavigationList,
          customerNavigationActiveLink
        } = getElementByRef$1(['customer-navigation-list', 'customer-navigation-active-link'], this);
        if (customerNavigationList) {
          this.navList = customerNavigationList;
          this.activeItem = customerNavigationActiveLink;
          this.setNavPosition();
        }
      }
      setNavPosition() {
        if (this.navList) {
          if (isMobile() && this.activeItem) {
            const navWidth = this.navList.offsetWidth;
            const activeItemPosition = this.activeItem.parentElement.offsetLeft;
            const activeItemWidth = this.activeItem.parentElement.offsetWidth;
            const scrollPosition = activeItemPosition - navWidth / 2 + activeItemWidth / 2;
            this.navList.scrollTo({
              left: scrollPosition,
              behavior: 'instant'
            });
          }
          this.navList.classList.add('is-revealed');
        }
      }
      static define() {
        if (!customElements.get('component-customer-nav')) {
          customElements.define('component-customer-nav', ComponentCustomerNav);
        }
      }
    }
    var componentCustomerNav = () => {
      ComponentCustomerNav.define();
    };

    var componentCustomerNav$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentCustomerNav
    });

    const {
      getElementByRef
    } = window.PoleneLibs.Refs;
    class ComponentCustomerOrderDetails extends HTMLElement {
      constructor() {
        super();
        this.controller = new AbortController();
      }
      connectedCallback() {
        this.initializeElements();
      }
      disconnectedCallback() {
        this.controller.abort();
      }
      updatedCallback() {
        this.controller.abort();
        this.controller = new AbortController();
      }
      initializeElements() {
        const orderId = this.getAttribute('data-order-id');
        if (!orderId) return;
        this.orderId = orderId;
        this.renderOrderDetails();
      }
      async fetchOrderDetails() {
        const response = await fetch(`${API_PROXY.ORDER_DETAILS_SAP}?order_id=${this.orderId}`, {
          signal: this.controller.signal
        });
        if (!response.ok) {
          throw new Error('Failed to fetch order details');
        }
        return await response.text();
      }
      async renderOrderDetails() {
        try {
          const orderDetails = await this.fetchOrderDetails();
          if (!orderDetails.trim()) {
            return;
          }
          this.innerHTML = orderDetails;
          const {
            accountOverviewOrderDetails
          } = getElementByRef('account-overview-order-details');
          if (accountOverviewOrderDetails) {
            accountOverviewOrderDetails.querySelector('.tracking-url')?.remove();
            accountOverviewOrderDetails.classList.add('is-revealed');
            accountOverviewOrderDetails.setAttribute('aria-hidden', 'false');
          }
        } catch (error) {}
      }
      static define = () => {
        if (!customElements.get('component-customer-order-details')) customElements.define('component-customer-order-details', ComponentCustomerOrderDetails);
      };
    }
    var componentCustomerOrderDetails = () => {
      ComponentCustomerOrderDetails.define();
    };

    var componentCustomerOrderDetails$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentCustomerOrderDetails
    });

    class InvoiceButton extends HTMLElement {
      controller = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListeners();
      }
      addEventListeners = () => {
        this.addEventListener('click', async () => {
          try {
            const response = await fetch(`${API_PROXY.ORDER_INVOICE}`, {
              signal: this.controller?.signal
            });
            const data = await response.json();
          } catch (error) {}
        }, {
          signal: this.controller?.signal
        });
      };
      disconnectedCallback() {
        this.controller?.abort();
      }
      static define = () => {
        if (!customElements.get('invoice-button')) {
          customElements.define('invoice-button', InvoiceButton);
        }
      };
    }
    var componentInvoiceButton = () => {
      InvoiceButton.define();
    };

    var componentInvoiceButton$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        InvoiceButton: InvoiceButton,
        default: componentInvoiceButton
    });

})();
